import { Notify as Ee, useQuasar as ye, QForm as Te, QInput as ie, QMenu as st, QList as at, QItem as rt, QItemSection as it, QSelect as so, QBtn as te, QDialog as $e, QPopupProxy as St, QDate as Et, ClosePopup as Tt, QIcon as xt, QCheckbox as be, QCard as ao, QCardSection as ro, Quasar as io, Loading as lt } from "quasar";
import { computed as de, shallowRef as Lt, isRef as Ue, watch as Fe, shallowReadonly as lo, readonly as Vt, getCurrentScope as co, onScopeDispose as uo, toValue as fe, toRef as fo, ref as V, customRef as po, reactive as Ce, unref as i, nextTick as Re, onMounted as _e, inject as me, createElementBlock as j, openBlock as x, createElementVNode as h, mergeModels as ke, useModel as qe, createBlock as D, withModifiers as K, withCtx as v, createCommentVNode as ae, createVNode as g, toDisplayString as N, withKeys as ue, createSlots as It, Fragment as Be, renderList as ct, createTextVNode as oe, useTemplateRef as ge, resolveComponent as W, withDirectives as De, normalizeClass as He, provide as Pt, mergeProps as $t, TransitionGroup as Rt, resolveDirective as Mt, defineCustomElement as je } from "vue";
import { createI18n as mo, useI18n as ve, I18nInjectionKey as Ge } from "vue-i18n";
import { parsePhoneNumberWithError as vo, parsePhoneNumberFromString as go } from "libphonenumber-js";
const yo = {
  login: {
    title: "Create an Account / Sign In",
    phoneRegisterTitle: "Mobile phone number registration",
    or: "or",
    benefits: {
      birthday: "Birthday Gift",
      points: "Rewards Points",
      freeGift: "Redeem Free Gifts"
    },
    form: {
      continue: "Continue",
      labelMobile: "Mobile phone",
      labelEmailOrMobile: "E-mail or Mobile phone",
      labelEmail: "E-mail",
      validateRequired: "Please enter your email or phone number",
      validatePhone: "Please enter a valid phone number",
      validateEmail: "Please enter a valid email address",
      validateEmailRequired: "Please enter your email"
    },
    actions: {
      change: "Change",
      signIn: "Sign In",
      createAccount: "Create account",
      forgotPassword: "Forgot password"
    },
    switch: {
      codeLogin: "Verification code login",
      passwordLogin: "Password login"
    },
    code: {
      label: "Verification Code",
      send: "Send",
      errorSendFail: "Failed to send verification code",
      errorSessionExpired: "The session has expired and needs to be restarted",
      errorIncorrect: "The verification code is incorrect",
      validateRequired: "Please enter the verification code",
      validateLength: "Please enter the correct verification code"
    },
    password: {
      label: "Password",
      validateRequired: "Please enter your password",
      validateLength: "Please enter a 6-digit password",
      errorIncorrect: "Incorrect password. Please try again."
    },
    birthday: {
      label_html: "Baby's Birthday / Due Date",
      placeholder_html: "Baby's Birthday / Due Date",
      validateRequired_html: "Please enter your Baby's Birthday / Due Date",
      validateInvalid_html: "Please enter your current Baby's Birthday / Due Date"
    },
    newsletter: {
      labelEmail: "I agree to receive marketing emails from Momcozy about parenting insights and exclusive offers. Unsubscribe anytime",
      labelPhone: "I agree to receive notifications and updates via my phone number"
    },
    common: {
      close: "Close",
      unknownError: "Unknown error",
      confirm: "Confirm"
    },
    account: {
      existsPhone: "The phone number has been registered, please change it",
      existsEmail: "The email has been registered, please change it"
    },
    terms: {
      full: "By selecting create account you agree to our {privacy} and {terms}",
      privacy: "Privacy Policy",
      terms_html: "Terms & Conditions",
      validateRequired: "Please agree to the terms to continue",
      policyInfo: "I agree to Momcozy’s {terms} and acknowledge that I have read and understood Momcozy’s {privacy}",
      policyTip_html: "<div style='text-align:center'>Please agree to the Terms of Service and Privacy Policy to create your account.</div>"
    },
    country: {
      us: "United States",
      ca: "Canada"
    }
  }
}, ho = {
  default: {
    ...yo,
    ...window?.__MOMCOZY_LOGIN_I18N__ || {}
  }
}, pe = mo({
  locale: "default",
  legacy: !1,
  escapeParameterHtml: !0,
  messages: ho
}), _o = "momcozy-token";
function ut() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName ? window.__MC__CONFIG__.cookieName : _o;
}
function bo(e) {
  const s = document.cookie.split(";").find((n) => n.trim().startsWith(`${e}=`));
  return s ? s.trim().substring(e.length + 1) : null;
}
function wo(e = window.location.hostname) {
  const t = e.split(".");
  return t.length <= 2 || e === "localhost" || /^\d{1,3}(?:\.\d{1,3}){3}$/.test(e) ? e : `.${t.slice(-2).join(".")}`;
}
function Ot() {
  return window.MC_CONFIG?.cookieDomain || wo();
}
function Co(e, t, s = 7, n = Ot()) {
  const r = new Date(Date.now() + s * 24 * 60 * 60 * 1e3).toUTCString();
  document.cookie = `${e}=${t}; expires=${r}; path=/; domain=${n}; SameSite=Lax`;
}
function ko(e, t = Ot()) {
  document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${t}; SameSite=Lax`;
}
function dt(e) {
  const t = ut();
  Co(t, e);
}
function Ze() {
  if (window.__MC__CONFIG__ && window.__MC__CONFIG__.token)
    return window.__MC__CONFIG__.token;
  const e = ut();
  return bo(e);
}
function Nt() {
  const e = ut();
  ko(e);
}
class So extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:EXPIRED", { detail: t });
  }
}
let Eo = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:LOGIN", { detail: t });
  }
}, To = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSE", { detail: t });
  }
}, xo = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSED", { detail: t });
  }
};
class Lo extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:HIDE", { detail: t });
  }
}
function At(e) {
  document.body.classList.remove("momcozy-logined"), document.dispatchEvent(new So(e));
}
const Vo = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, Io = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, Po = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $o(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    Ro(e);
    return;
  }
  return t;
}
function Ro(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function Mo(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const s = e.trim();
  if (s.length <= 9)
    switch (s.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!Po.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (Vo.test(e) || Io.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, $o);
    }
    return JSON.parse(e);
  } catch (n) {
    if (t.strict)
      throw n;
    return e;
  }
}
const Oo = /#/g, No = /&/g, Ao = /\//g, Uo = /=/g, ft = /\+/g, Fo = /%5e/gi, qo = /%60/gi, Bo = /%7c/gi, Do = /%20/gi;
function Ho(e) {
  return encodeURI("" + e).replace(Bo, "|");
}
function tt(e) {
  return Ho(typeof e == "string" ? e : JSON.stringify(e)).replace(ft, "%2B").replace(Do, "+").replace(Oo, "%23").replace(No, "%26").replace(qo, "`").replace(Fo, "^").replace(Ao, "%2F");
}
function Ke(e) {
  return tt(e).replace(Uo, "%3D");
}
function Ut(e = "") {
  try {
    return decodeURIComponent("" + e);
  } catch {
    return "" + e;
  }
}
function jo(e) {
  return Ut(e.replace(ft, " "));
}
function Go(e) {
  return Ut(e.replace(ft, " "));
}
function Zo(e = "") {
  const t = /* @__PURE__ */ Object.create(null);
  e[0] === "?" && (e = e.slice(1));
  for (const s of e.split("&")) {
    const n = s.match(/([^=]+)=?(.*)/) || [];
    if (n.length < 2)
      continue;
    const r = jo(n[1]);
    if (r === "__proto__" || r === "constructor")
      continue;
    const l = Go(n[2] || "");
    t[r] === void 0 ? t[r] = l : Array.isArray(t[r]) ? t[r].push(l) : t[r] = [t[r], l];
  }
  return t;
}
function zo(e, t) {
  return (typeof t == "number" || typeof t == "boolean") && (t = String(t)), t ? Array.isArray(t) ? t.map(
    (s) => `${Ke(e)}=${tt(s)}`
  ).join("&") : `${Ke(e)}=${tt(t)}` : Ke(e);
}
function Qo(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).map((t) => zo(t, e[t])).filter(Boolean).join("&");
}
const Yo = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, Xo = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, Wo = /^([/\\]\s*){2,}[^/\\]/, Ko = /^\.?\//;
function Ft(e, t = {}) {
  return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? Yo.test(e) : Xo.test(e) || (t.acceptRelative ? Wo.test(e) : !1);
}
function Jo(e = "", t) {
  return e.endsWith("/");
}
function en(e = "", t) {
  return (Jo(e) ? e.slice(0, -1) : e) || "/";
}
function tn(e = "", t) {
  return e.endsWith("/") ? e : e + "/";
}
function on(e, t) {
  if (sn(t) || Ft(e))
    return e;
  const s = en(t);
  return e.startsWith(s) ? e : rn(s, e);
}
function nn(e, t) {
  const s = ln(e), n = { ...Zo(s.search), ...t };
  return s.search = Qo(n), cn(s);
}
function sn(e) {
  return !e || e === "/";
}
function an(e) {
  return e && e !== "/";
}
function rn(e, ...t) {
  let s = e || "";
  for (const n of t.filter((r) => an(r)))
    if (s) {
      const r = n.replace(Ko, "");
      s = tn(s) + r;
    } else
      s = n;
  return s;
}
const qt = /* @__PURE__ */ Symbol.for("ufo:protocolRelative");
function ln(e = "", t) {
  const s = e.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (s) {
    const [, m, C = ""] = s;
    return {
      protocol: m.toLowerCase(),
      pathname: C,
      href: m + C,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!Ft(e, { acceptRelative: !0 }))
    return ht(e);
  const [, n = "", r, l = ""] = e.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, u = "", o = ""] = l.match(/([^#/?]*)(.*)?/) || [];
  n === "file:" && (o = o.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: c, search: d, hash: a } = ht(o);
  return {
    protocol: n.toLowerCase(),
    auth: r ? r.slice(0, Math.max(0, r.length - 1)) : "",
    host: u,
    pathname: c,
    search: d,
    hash: a,
    [qt]: !n
  };
}
function ht(e = "") {
  const [t = "", s = "", n = ""] = (e.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: t,
    search: s,
    hash: n
  };
}
function cn(e) {
  const t = e.pathname || "", s = e.search ? (e.search.startsWith("?") ? "" : "?") + e.search : "", n = e.hash || "", r = e.auth ? e.auth + "@" : "", l = e.host || "";
  return (e.protocol || e[qt] ? (e.protocol || "") + "//" : "") + r + l + t + s + n;
}
class un extends Error {
  constructor(t, s) {
    super(t, s), this.name = "FetchError", s?.cause && !this.cause && (this.cause = s.cause);
  }
}
function dn(e) {
  const t = e.error?.message || e.error?.toString() || "", s = e.request?.method || e.options?.method || "GET", n = e.request?.url || String(e.request) || "/", r = `[${s}] ${JSON.stringify(n)}`, l = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", u = `${r}: ${l}${t ? ` ${t}` : ""}`, o = new un(
    u,
    e.error ? { cause: e.error } : void 0
  );
  for (const c of ["request", "options", "response"])
    Object.defineProperty(o, c, {
      get() {
        return e[c];
      }
    });
  for (const [c, d] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(o, c, {
      get() {
        return e.response && e.response[d];
      }
    });
  return o;
}
const fn = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function _t(e = "GET") {
  return fn.has(e.toUpperCase());
}
function pn(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer || e instanceof FormData || e instanceof URLSearchParams ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const mn = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), vn = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function gn(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return vn.test(t) ? "json" : t === "text/event-stream" ? "stream" : mn.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function yn(e, t, s, n) {
  const r = hn(
    t?.headers ?? e?.headers,
    s?.headers,
    n
  );
  let l;
  return (s?.query || s?.params || t?.params || t?.query) && (l = {
    ...s?.params,
    ...s?.query,
    ...t?.params,
    ...t?.query
  }), {
    ...s,
    ...t,
    query: l,
    params: l,
    headers: r
  };
}
function hn(e, t, s) {
  if (!t)
    return new s(e);
  const n = new s(t);
  if (e)
    for (const [r, l] of Symbol.iterator in e || Array.isArray(e) ? e : new s(e))
      n.set(r, l);
  return n;
}
async function xe(e, t) {
  if (t)
    if (Array.isArray(t))
      for (const s of t)
        await s(e);
    else
      await t(e);
}
const _n = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), bn = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function Bt(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: s = globalThis.Headers,
    AbortController: n = globalThis.AbortController
  } = e;
  async function r(o) {
    const c = o.error && o.error.name === "AbortError" && !o.options.timeout || !1;
    if (o.options.retry !== !1 && !c) {
      let a;
      typeof o.options.retry == "number" ? a = o.options.retry : a = _t(o.options.method) ? 0 : 1;
      const m = o.response && o.response.status || 500;
      if (a > 0 && (Array.isArray(o.options.retryStatusCodes) ? o.options.retryStatusCodes.includes(m) : _n.has(m))) {
        const C = typeof o.options.retryDelay == "function" ? o.options.retryDelay(o) : o.options.retryDelay || 0;
        return C > 0 && await new Promise((y) => setTimeout(y, C)), l(o.request, {
          ...o.options,
          retry: a - 1
        });
      }
    }
    const d = dn(o);
    throw Error.captureStackTrace && Error.captureStackTrace(d, l), d;
  }
  const l = async function(c, d = {}) {
    const a = {
      request: c,
      options: yn(
        c,
        d,
        e.defaults,
        s
      ),
      response: void 0,
      error: void 0
    };
    if (a.options.method && (a.options.method = a.options.method.toUpperCase()), a.options.onRequest && (await xe(a, a.options.onRequest), a.options.headers instanceof s || (a.options.headers = new s(
      a.options.headers || {}
      /* compat */
    ))), typeof a.request == "string" && (a.options.baseURL && (a.request = on(a.request, a.options.baseURL)), a.options.query && (a.request = nn(a.request, a.options.query), delete a.options.query), "query" in a.options && delete a.options.query, "params" in a.options && delete a.options.params), a.options.body && _t(a.options.method))
      if (pn(a.options.body)) {
        const y = a.options.headers.get("content-type");
        typeof a.options.body != "string" && (a.options.body = y === "application/x-www-form-urlencoded" ? new URLSearchParams(
          a.options.body
        ).toString() : JSON.stringify(a.options.body)), y || a.options.headers.set("content-type", "application/json"), a.options.headers.has("accept") || a.options.headers.set("accept", "application/json");
      } else // ReadableStream Body
      ("pipeTo" in a.options.body && typeof a.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof a.options.body.pipe == "function") && ("duplex" in a.options || (a.options.duplex = "half"));
    let m;
    if (!a.options.signal && a.options.timeout) {
      const y = new n();
      m = setTimeout(() => {
        const b = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        b.name = "TimeoutError", b.code = 23, y.abort(b);
      }, a.options.timeout), a.options.signal = y.signal;
    }
    try {
      a.response = await t(
        a.request,
        a.options
      );
    } catch (y) {
      return a.error = y, a.options.onRequestError && await xe(
        a,
        a.options.onRequestError
      ), await r(a);
    } finally {
      m && clearTimeout(m);
    }
    if ((a.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    a.response._bodyInit) && !bn.has(a.response.status) && a.options.method !== "HEAD") {
      const y = (a.options.parseResponse ? "json" : a.options.responseType) || gn(a.response.headers.get("content-type") || "");
      switch (y) {
        case "json": {
          const b = await a.response.text(), T = a.options.parseResponse || Mo;
          a.response._data = T(b);
          break;
        }
        case "stream": {
          a.response._data = a.response.body || a.response._bodyInit;
          break;
        }
        default:
          a.response._data = await a.response[y]();
      }
    }
    return a.options.onResponse && await xe(
      a,
      a.options.onResponse
    ), !a.options.ignoreResponseError && a.response.status >= 400 && a.response.status < 600 ? (a.options.onResponseError && await xe(
      a,
      a.options.onResponseError
    ), await r(a)) : a.response;
  }, u = async function(c, d) {
    return (await l(c, d))._data;
  };
  return u.raw = l, u.native = (...o) => t(...o), u.create = (o = {}, c = {}) => Bt({
    ...e,
    ...c,
    defaults: {
      ...e.defaults,
      ...c.defaults,
      ...o
    }
  }), u;
}
const Me = (function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
})(), wn = Me.fetch ? (...e) => Me.fetch(...e) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), Cn = Me.Headers, kn = Me.AbortController, Dt = Bt({ fetch: wn, Headers: Cn, AbortController: kn }), Sn = {};
function En() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.accountSiteUrl ? window.__MC__CONFIG__.accountSiteUrl : "https://account.momcozy.com";
}
function Ht() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl ? window.__MC__CONFIG__.apiUrl : "https://account.momcozy.com";
}
function jt(e) {
  const s = new TextEncoder().encode(e);
  let n = "";
  for (let r = 0; r < s.length; r++)
    n += String.fromCharCode(s[r]);
  return btoa(n);
}
const Tn = "5waV6ARzSxRgap4h", xn = { memorySize: 4096, iterations: 2, parallelism: 1, hashLength: 32 };
async function ze(e) {
  const { argon2id: t } = await import("hash-wasm"), s = Uint8Array.from(atob(Tn), (l) => l.charCodeAt(0)), n = await t({
    password: e,
    salt: s,
    ...xn,
    outputType: "binary"
  });
  let r = "";
  for (let l = 0; l < n.length; l++)
    r += String.fromCharCode(n[l]);
  return btoa(r);
}
function Ln() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.headers ? window.__MC__CONFIG__.headers : {
    "X-STORE-CODE": (typeof import.meta < "u" && Sn && "production" || typeof process < "u" && process.env && process.env.NODE_ENV || "") === "development" ? "MOMCOZY_US_TEST" : "MOMCOZY_US"
  };
}
const Vn = Ht(), Oe = Dt.create({
  baseURL: Vn,
  onRequest({ options: e }) {
    const t = Ze();
    e.headers = {
      ...e.headers,
      authorization: `Bearer ${t}`
    };
  },
  onResponse({ response: e }) {
    const t = e._data;
    t && ((t.code === "10001003" || t.code === "10001002") && At(t), t && Reflect.has(t, "result") && (e._data = t.result));
  }
});
Oe.get = (e, t) => Oe(e, { method: "GET", ...t });
Oe.post = (e, t) => Oe(e, { method: "POST", ...t });
const pt = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i, Gt = "https://app.cozyinnov.com/app/privacy";
class In extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:LOGIN", { detail: t });
  }
}
class Pn extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSE", { detail: t });
  }
}
class $n extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSED", { detail: t });
  }
}
class Ne extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:THIRD-LOGIN:SUCCESS", { detail: t });
  }
}
const Rn = Ht(), Mn = Ln(), Q = Dt.create({
  baseURL: Rn,
  onRequest({ options: e }) {
    if (e.needToken) {
      const t = Ze();
      t && (e.headers = {
        ...e.headers,
        authorization: `Bearer ${t}`
      });
    }
    e.headers = {
      ...e.headers,
      ...Mn
    };
  },
  onResponse({ response: e }) {
    const t = e._data;
    t && ((t.code === "10001003" || t.code === "10001002") && At(t), (t.code === "10004003" || t.code === "10004510") && Ee.create({
      type: "negative",
      message: t.message,
      position: "center",
      timeout: 3e3
    }), t && Object.prototype.hasOwnProperty.call(t, "result") && (e._data = t.result));
  }
});
Q.get = (e, t, s) => Q(e, { ...s, method: "GET", params: t });
Q.post = (e, t, s) => Q(e, { ...s, method: "POST", body: t });
function On(e, t = void 0) {
  if (!e || typeof e != "string")
    return !1;
  const s = go(e, t);
  return !!s && s.isValid();
}
function Nn(e, t = void 0) {
  const s = vo(e, t);
  return {
    displayNumber: s.formatInternational(),
    number: s.number
  };
}
function Zt(e) {
  return Q.get("/api/station/user/getUserInfo/v2", e, { needToken: !0 });
}
function An(e) {
  return Q.post("/api/station/user/login/preCheck", e);
}
function Qe(e) {
  return Q.post("/api/station/user/login/init", e);
}
function zt(e, t = {}) {
  const s = new URLSearchParams(Object.entries(t)).toString();
  return Q.post(`/api/station/user/sendVerifyCode${s ? `?${s}` : ""}`, e);
}
function Un(e) {
  return Q.post("/api/station/user/login", e);
}
function Fn(e) {
  return Q.post("/api/station/user/loginByCode", e);
}
function qn(e) {
  return Q.post("/api/station/user/checkUserAccount", e);
}
function Bn(e) {
  return Q.post("/api/station/user/verifyCode", e);
}
function Qt(e) {
  return Q.post("/api/station/user/registerByCode", e);
}
async function mt(e, t, s) {
  return await Q.post(`/api/station/user/oauth/login/${e}`, t, s);
}
async function Dn(e, t) {
  return await Q.post("/api/station/user/social/sendMailCode", e, t);
}
async function Hn(e, t) {
  return await Q.post("/api/station/user/social/verifyMailCode", e, t);
}
async function jn(e, t) {
  return await Q.post("/api/station/user/social/verifyPass", e, t);
}
async function Gn(e, t) {
  return await Q.post("/api/station/user/quick/register", e, t);
}
async function Zn(e) {
  return await Q.get("/api/station/user/get/privacyPolicy", {
    protocolType: 1,
    client: 1,
    ...e
  });
}
async function Se(e = {}) {
  return await Q.post("/api/base/event/report", e);
}
const zn = /^[0-9|\-() ]+$/;
function Yt(e, t) {
  const s = de(() => ["US", "CA"].includes(t.value.country)), n = de(() => e.value.account && s.value && zn.test(e.value.account));
  async function r() {
    const l = n.value ? Nn(`+${e.value.areaCode.displayValue}${e.value.account}`, t.value.country) : null, u = {
      email: n.value ? "" : e.value.account,
      phone: n.value ? l.number : "",
      type: n.value ? 2 : 1
    }, o = await An(u);
    if (!o)
      throw new Error("Pre-check failed");
    return {
      account: n.value ? l.displayNumber : e.value.account,
      realPhone: n.value ? l.number : "",
      loginType: o.nextFlow === 1 ? "login" : "register",
      loginMethod: n.value ? "phone" : "email",
      passwordType: n.value ? "code" : "password"
    };
  }
  return {
    isPhoneNum: n,
    isSupportPhoneNum: s,
    handleCheck: r
  };
}
function ot(e) {
  return co() ? (uo(e), !0) : !1;
}
const nt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Qn = Object.prototype.toString, Yn = (e) => Qn.call(e) === "[object Object]", Xn = () => {
};
function Wn(...e) {
  if (e.length !== 1)
    return fo(...e);
  const t = e[0];
  return typeof t == "function" ? Vt(po(() => ({ get: t, set: Xn }))) : V(t);
}
function Kn(e, t) {
  function s(...n) {
    return new Promise((r, l) => {
      Promise.resolve(e(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(r).catch(l);
    });
  }
  return s;
}
const Xt = (e) => e();
function Jn(e = Xt, t = {}) {
  const {
    initialState: s = "active"
  } = t, n = Wn(s === "active");
  function r() {
    n.value = !1;
  }
  function l() {
    n.value = !0;
  }
  const u = (...o) => {
    n.value && e(...o);
  };
  return { isActive: Vt(n), pause: r, resume: l, eventFilter: u };
}
function Je(e) {
  return Array.isArray(e) ? e : [e];
}
function es(e, t, s = {}) {
  const {
    eventFilter: n = Xt,
    ...r
  } = s;
  return Fe(
    e,
    Kn(
      n,
      t
    ),
    r
  );
}
function ts(e, t, s = {}) {
  const {
    eventFilter: n,
    initialState: r = "active",
    ...l
  } = s, { eventFilter: u, pause: o, resume: c, isActive: d } = Jn(n, { initialState: r });
  return { stop: es(
    e,
    t,
    {
      ...l,
      eventFilter: u
    }
  ), pause: o, resume: c, isActive: d };
}
function os(e, t = 1e3, s = {}) {
  const {
    immediate: n = !0,
    immediateCallback: r = !1
  } = s;
  let l = null;
  const u = Lt(!1);
  function o() {
    l && (clearInterval(l), l = null);
  }
  function c() {
    u.value = !1, o();
  }
  function d() {
    const a = fe(t);
    a <= 0 || (u.value = !0, r && e(), o(), u.value && (l = setInterval(e, a)));
  }
  if (n && nt && d(), Ue(t) || typeof t == "function") {
    const a = Fe(t, () => {
      u.value && nt && d();
    });
    ot(a);
  }
  return ot(c), {
    isActive: lo(u),
    pause: c,
    resume: d
  };
}
function ns(e, t, s) {
  return Fe(
    e,
    t,
    {
      ...s,
      immediate: !0
    }
  );
}
const Wt = nt ? window : void 0;
function ss(e) {
  var t;
  const s = fe(e);
  return (t = s?.$el) != null ? t : s;
}
function bt(...e) {
  const t = [], s = () => {
    t.forEach((o) => o()), t.length = 0;
  }, n = (o, c, d, a) => (o.addEventListener(c, d, a), () => o.removeEventListener(c, d, a)), r = de(() => {
    const o = Je(fe(e[0])).filter((c) => c != null);
    return o.every((c) => typeof c != "string") ? o : void 0;
  }), l = ns(
    () => {
      var o, c;
      return [
        (c = (o = r.value) == null ? void 0 : o.map((d) => ss(d))) != null ? c : [Wt].filter((d) => d != null),
        Je(fe(r.value ? e[1] : e[0])),
        Je(i(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        fe(r.value ? e[3] : e[2])
      ];
    },
    ([o, c, d, a]) => {
      if (s(), !o?.length || !c?.length || !d?.length)
        return;
      const m = Yn(a) ? { ...a } : a;
      t.push(
        ...o.flatMap(
          (C) => c.flatMap(
            (y) => d.map((b) => n(C, y, b, m))
          )
        )
      );
    },
    { flush: "post" }
  ), u = () => {
    l(), s();
  };
  return ot(s), u;
}
function Kt(e, t) {
  var s, n;
  const r = Lt(fe(e)), l = os(() => {
    var a, m;
    const C = r.value - 1;
    r.value = C < 0 ? 0 : C, (a = void 0) == null || a.call(t), r.value <= 0 && (l.pause(), (m = void 0) == null || m.call(t));
  }, (s = void 0) != null ? s : 1e3, { immediate: (n = void 0) != null ? n : !1 }), u = (a) => {
    var m;
    r.value = (m = fe(a)) != null ? m : fe(e);
  }, o = () => {
    l.pause(), u();
  }, c = () => {
    l.isActive.value || r.value > 0 && l.resume();
  };
  return {
    remaining: r,
    reset: u,
    stop: o,
    start: (a) => {
      u(a), l.resume();
    },
    pause: l.pause,
    resume: c,
    isActive: l.isActive
  };
}
function Jt(e = "history", t = {}) {
  const {
    initialValue: s = {},
    removeNullishValues: n = !0,
    removeFalsyValues: r = !1,
    write: l = !0,
    writeMode: u = "replace",
    window: o = Wt,
    stringify: c = (O) => O.toString()
  } = t;
  if (!o)
    return Ce(s);
  const d = Ce({});
  function a() {
    if (e === "history")
      return o.location.search || "";
    if (e === "hash") {
      const O = o.location.hash || "", S = O.indexOf("?");
      return S > 0 ? O.slice(S) : "";
    } else
      return (o.location.hash || "").replace(/^#/, "");
  }
  function m(O) {
    const S = c(O);
    if (e === "history")
      return `${S ? `?${S}` : ""}${o.location.hash || ""}`;
    if (e === "hash-params")
      return `${o.location.search || ""}${S ? `#${S}` : ""}`;
    const w = o.location.hash || "#", E = w.indexOf("?");
    return E > 0 ? `${o.location.search || ""}${w.slice(0, E)}${S ? `?${S}` : ""}` : `${o.location.search || ""}${w}${S ? `?${S}` : ""}`;
  }
  function C() {
    return new URLSearchParams(a());
  }
  function y(O) {
    const S = new Set(Object.keys(d));
    for (const w of O.keys()) {
      const E = O.getAll(w);
      d[w] = E.length > 1 ? E : O.get(w) || "", S.delete(w);
    }
    Array.from(S).forEach((w) => delete d[w]);
  }
  const { pause: b, resume: T } = ts(
    d,
    () => {
      const O = new URLSearchParams("");
      Object.keys(d).forEach((S) => {
        const w = d[S];
        Array.isArray(w) ? w.forEach((E) => O.append(S, E)) : n && w == null || r && !w ? O.delete(S) : O.set(S, w);
      }), k(O, !1);
    },
    { deep: !0 }
  );
  function k(O, S, w = !0) {
    b(), S && y(O), u === "replace" ? o.history.replaceState(
      o.history.state,
      o.document.title,
      o.location.pathname + m(O)
    ) : w && o.history.pushState(
      o.history.state,
      o.document.title,
      o.location.pathname + m(O)
    ), Re(() => T());
  }
  function I() {
    l && k(C(), !0, !1);
  }
  const A = { passive: !0 };
  bt(o, "popstate", I, A), e !== "history" && bt(o, "hashchange", I, A);
  const U = C();
  return U.keys().next().value ? y(U) : Object.assign(d, s), d;
}
function eo(e) {
  const t = Jt("history"), s = t.utm_medium || t.source, n = V("");
  return _e(async () => {
    const { versionNumber: l } = await Zn({ countryCode: e.value.country });
    n.value = l;
  }), de(() => ({
    platForm: "SHOPIFY",
    registerSource: (s ? `${e.value.activityType}_${s}` : e.value.activityType) || "",
    registerChannel: t.channel || "shopify_web",
    redirect: e.value.redirect || location.href,
    utmCampaign: t.utm_campaign || "",
    agreePrivacyVersion: n.value
  }));
}
function vt(e) {
  const t = Jt("history"), s = t.utm_medium || t.source;
  return de(() => {
    const r = s ? `${e.value.activityType}_${s}` : e.value.activityType;
    return {
      platForm: "SHOPIFY",
      entryPage: window.location.href,
      registerSource: r || "",
      utmCampaign: t.utm_campaign || "",
      utmSource: t.utm_source || "",
      utmMedium: t.utm_medium || "",
      country: e.value.country || "",
      referer: document.referrer || "",
      title: document.title || "",
      osVersion: navigator.userAgent || "",
      languageCode: navigator.language || "",
      manufacturer: navigator.vendor || "",
      screenWidth: window.screen.width || "",
      screenHeight: window.screen.height || "",
      platform: window.innerWidth < 768 ? "H5" : "WEB",
      shopCode: window.__MC__CONFIG__ && window.__MC__CONFIG__.shopCode || "",
      time: (/* @__PURE__ */ new Date()).getTime()
    };
  });
}
const Ae = () => `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 9)}`, wt = {
  get: (e) => sessionStorage.getItem(e) || "",
  set: (e, t) => sessionStorage.setItem(e, t)
}, as = (e) => {
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? "" : t.toISOString().replace(/\.\d{3}Z$/, "Z");
}, rs = (e, t) => {
  const s = e - (t || 0) * 60 * 1e3, n = new Date(s);
  if (Number.isNaN(n.getTime())) return "";
  const r = (l) => String(l).padStart(2, "0");
  return `${n.getFullYear()}-${r(n.getMonth() + 1)}-${r(n.getDate())}T${r(n.getHours())}:${r(n.getMinutes())}:${r(n.getSeconds())}`;
}, is = () => {
  let e = wt.get("__edm_session_id");
  return e || (e = `ses_${Ae()}`, wt.set("__edm_session_id", e)), e;
}, ls = () => `pv_${Ae()}`, Ct = {
  page_type: "member_center",
  page_id: "register_popup"
};
function cs(e, t) {
  return (e?.value || e || {}).userInfo?.uid || t.__MC__CONFIG__?.userInfo?.uid || "";
}
function us(e) {
  const t = () => {
    const o = window, c = document, d = new URL(o.location.href), a = Object.fromEntries(d.searchParams.entries()), m = o.innerWidth >= 1024 ? "pc" : o.innerWidth >= 768 ? "tablet" : "mobile", C = o.innerWidth < 768 ? "h5" : "web";
    return {
      event_id: Ae(),
      event_time_utc: as(Date.now()),
      local_time: rs(Date.now(), (/* @__PURE__ */ new Date()).getTimezoneOffset()),
      anonymous_id: o.__MC__ID__ || "",
      user_id: cs(e, o),
      visitor_id: o.__MC__ID__ || "",
      session_id: is(),
      page_view_id: ls(),
      site: o.__MC__CONFIG__ && o.__MC__CONFIG__.shopCode || "us",
      market: e.country || "US",
      locale: a.locale || o.navigator.language || "en-US",
      device: m,
      platform: C,
      page_id: Ct.page_id,
      page_type: Ct.page_type,
      page_url: o.location.href,
      page_path: o.location.pathname,
      referrer_url: c.referrer || "",
      utm_source: a.utm_source || "",
      utm_medium: a.utm_medium || "",
      utm_campaign: a.utm_campaign || "",
      utm_content: a.utm_content || ""
    };
  }, s = "shopify_register_popup", n = (o, c) => {
    if (!o || !ds()) return;
    const d = /* @__PURE__ */ new Set(), a = new IntersectionObserver((m) => {
      m.forEach((C) => {
        C.isIntersecting && C.intersectionRatio >= 0.5 && (d.has(C.target) || (d.add(C.target), u("email_subscribe_view", {
          subscription_entry_id: s,
          component_type: "checkbox",
          component_instance_id: "register_subscribe_checkbox",
          default_checked: !!c
        }), a.disconnect()));
      });
    }, { threshold: 0.5 });
    a.observe(o);
  }, r = async (o) => {
    const c = `req_${Ae()}`, { email_input_state: d, consent_state: a } = o;
    return await u("email_subscribe_click", {
      subscription_entry_id: s,
      subscribe_source: "register_submit_button",
      component_type: "form",
      component_instance_id: "register_subscribe_checkbox",
      submit_action: "register",
      email_input_state: d,
      consent_state: a,
      request_id: c
    }), c;
  }, l = (o) => {
    u("email_subscribe_submit_fail", {
      subscription_entry_id: s,
      component_type: "form",
      component_instance_id: "register_subscribe_checkbox",
      sync_result: "failed",
      ...o
    });
  }, u = async (o, c) => Se({
    eventName: o,
    eventType: o,
    content: {
      ...t(),
      ...c
    }
  }).catch(() => {
  });
  return {
    trackSubscribeView: n,
    trackSubscribeClick: r,
    trackSubscribeFail: l
  };
}
function ds() {
  return typeof IntersectionObserver < "u";
}
const et = [
  "@gmail.com",
  "@hotmail.com",
  "@yahoo.es",
  "@hotmail.es",
  "@yahoo.com",
  "@telefonica.net",
  "@outlook.com"
];
function gt(e) {
  const t = V(!1), s = V(-1), n = de(() => e.value.account.includes("@"));
  function r() {
    const a = e.value.account, m = a.lastIndexOf("@");
    return m === -1 ? "" : a.slice(m);
  }
  const l = de(() => {
    if (!n.value)
      return [];
    const a = r();
    return a ? et.filter((m) => m.startsWith(a)) : et;
  });
  function u(a) {
    const m = e.value.account, C = m.lastIndexOf("@"), y = m.slice(0, C);
    e.value.account = y + a;
  }
  function o(a) {
    t.value || (t.value = !0);
    const m = l.value;
    m.length && (s.value = (s.value + a + m.length) % m.length);
  }
  function c() {
    const a = l.value;
    s.value >= 0 && s.value < a.length && u(a[s.value]);
  }
  function d(a) {
    const m = e.value.account, C = m.lastIndexOf("@");
    if (C === -1)
      return a;
    const y = m.slice(C);
    return y ? a.replace(new RegExp(y.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), (b) => `<b style="color:#b27a7e">${b}</b>`) : a;
  }
  return Fe(() => e.value.account, () => {
    if (!l.value.length)
      return;
    const a = r();
    if (et.includes(a)) {
      t.value = !1;
      return;
    }
    t.value = !0;
  }), {
    suggestionMenu: t,
    activeSuggestionIndex: s,
    prependEmail: n,
    computedEmailOptions: l,
    selectEmailOption: u,
    moveSuggestion: o,
    applyActiveSuggestion: c,
    highlightSuggestion: d
  };
}
class we extends Error {
  constructor(t) {
    super(t), this.name = "VerificationCodeError";
  }
}
const kt = V("");
function yt(e) {
  const { t } = ve(), s = V(!1), { remaining: n, start: r } = Kt(0);
  async function l(c) {
    const d = await Qe({
      platForm: "SHOPIFY",
      countryCode: e.value.countryCode,
      countryName: e.value.countryName,
      redirectUrl: c
    });
    kt.value = d.sid || "";
  }
  function u(c) {
    if (!(c.status === 10 || c.status === 0))
      return c && c.status === 11 ? (l(), t("login.code.errorSessionExpired")) : c && c.status === 12 ? t("login.code.errorIncorrect") : t("login.common.unknownError");
  }
  async function o(c, d = {}) {
    if ((await qn(c)).status !== 1) {
      const C = c.type === 2 ? t("login.account.existsPhone") : t("login.account.existsEmail");
      throw new we(C);
    }
    const m = await zt(c, d);
    if (Reflect.has(m, "message"))
      throw new we(m.message || t("login.code.errorSendFail"));
    if (!m.codeLength)
      throw new we(u(m));
  }
  return {
    sid: kt,
    verifyCodeSending: s,
    remaining: n,
    start: r,
    sendVerificationCode: o,
    getVerifyCodeError: u,
    getInitSid: l
  };
}
const fs = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26415)'%3e%3cpath%20d='M40.24%2035.3791C39.7863%2036.4272%2039.2492%2037.392%2038.627%2038.279C37.7789%2039.4882%2037.0845%2040.3253%2036.5493%2040.7901C35.7197%2041.553%2034.8309%2041.9437%2033.879%2041.966C33.1957%2041.966%2032.3717%2041.7715%2031.4125%2041.3771C30.4501%2040.9845%2029.5657%2040.7901%2028.757%2040.7901C27.9089%2040.7901%2026.9993%2040.9845%2026.0263%2041.3771C25.0519%2041.7715%2024.2669%2041.9771%2023.6668%2041.9974C22.754%2042.0363%2021.8442%2041.6345%2020.9361%2040.7901C20.3565%2040.2845%2019.6315%2039.4179%2018.763%2038.1901C17.8312%2036.8791%2017.0651%2035.3587%2016.465%2033.6255C15.8222%2031.7533%2015.5%2029.9404%2015.5%2028.1853C15.5%2026.1748%2015.9344%2024.4407%2016.8046%2022.9876C17.4885%2021.8204%2018.3982%2020.8997%2019.5369%2020.2238C20.6756%2019.5479%2021.9059%2019.2035%2023.2309%2019.1815C23.9558%2019.1815%2024.9066%2019.4057%2026.088%2019.8464C27.2661%2020.2886%2028.0226%2020.5129%2028.3542%2020.5129C28.6022%2020.5129%2029.4425%2020.2507%2030.8671%2019.7279C32.2143%2019.2431%2033.3513%2019.0424%2034.2827%2019.1215C36.8067%2019.3252%2038.703%2020.3201%2039.964%2022.1127C37.7067%2023.4804%2036.5901%2025.3961%2036.6123%2027.8536C36.6327%2029.7678%2037.3271%2031.3607%2038.6919%2032.6255C39.3103%2033.2125%2040.0011%2033.6662%2040.7696%2033.9884C40.6029%2034.4717%2040.427%2034.9347%2040.24%2035.3791ZM34.4512%2012.6002C34.4512%2014.1005%2033.9031%2015.5014%2032.8106%2016.798C31.4921%2018.3394%2029.8973%2019.2302%2028.1679%2019.0896C28.1459%2018.9096%2028.1331%2018.7202%2028.1331%2018.5211C28.1331%2017.0808%2028.7601%2015.5393%2029.8736%2014.279C30.4295%2013.6409%2031.1365%2013.1103%2031.9939%2012.687C32.8494%2012.2701%2033.6587%2012.0395%2034.4198%2012C34.442%2012.2006%2034.4512%2012.4012%2034.4512%2012.6002V12.6002Z'%20fill='black'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26415'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2012)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", le = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [n, r] of t)
    s[n] = r;
  return s;
}, ps = {
  __name: "index",
  setup(e) {
    const t = ye(), s = me("config");
    function n() {
      r();
    }
    async function r() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const u = await Qe({
          platForm: "SHOPIFY",
          countryCode: s.value.country || "US",
          countryName: s.value.countryName || "United States",
          redirectUrl: s.value.redirect || location.href,
          registerSource: s.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "apple_login_redirect",
          s.value.redirect || location.href
        );
        const o = u.sid || "", c = await mt("apple_shopify", { sid: o, redirectUri: `${location.origin}/pages/third-login-auth?channel=apple_shopify` });
        window.location.href = c;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    async function l() {
      n();
    }
    return (u, o) => (x(), j("div", {
      class: "apple-login",
      onClick: l
    }, [...o[0] || (o[0] = [
      h("img", {
        src: fs,
        alt: ""
      }, null, -1)
    ])]));
  }
}, ms = /* @__PURE__ */ le(ps, [["__scopeId", "data-v-fc959438"]]), vs = { class: "mc-login__title" }, gs = {
  key: 0,
  class: "mc-login__description"
}, ys = ["innerHTML"], hs = {
  __name: "checkForm",
  props: /* @__PURE__ */ ke({
    intelCodeList: { type: Array, default: () => [] }
  }, {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  }),
  emits: /* @__PURE__ */ ke(["step"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, n = qe(e, "form"), { t: r } = ve(), l = me("config"), {
      suggestionMenu: u,
      activeSuggestionIndex: o,
      computedEmailOptions: c,
      selectEmailOption: d,
      moveSuggestion: a,
      applyActiveSuggestion: m,
      highlightSuggestion: C
    } = gt(n), { isPhoneNum: y, isSupportPhoneNum: b, handleCheck: T } = Yt(n, l), k = de(() => y.value ? r("login.form.labelMobile") : !n.value.account && b.value ? r("login.form.labelEmailOrMobile") : r("login.form.labelEmail"));
    function I() {
      if (!n.value.account)
        return r("login.form.validateRequired");
      if (y.value && !On(`+1${n.value.account}`))
        return r("login.form.validatePhone");
      if (!y.value && !pt.test(n.value.account))
        return r("login.form.validateEmail");
    }
    const A = V(!1);
    async function U() {
      try {
        A.value = !0;
        const O = await T();
        s("step", O);
      } finally {
        A.value = !1;
      }
    }
    return (O, S) => (x(), D(i(Te), {
      class: "mc-login__card mc-check",
      onSubmit: K(U, ["prevent"])
    }, {
      default: v(() => [
        h("div", vs, N(i(l).customTitle || i(r)("login.title")), 1),
        i(l).customDescription ? (x(), j("div", gs, N(i(l).customDescription), 1)) : ae("", !0),
        g(i(ie), {
          modelValue: n.value.account,
          "onUpdate:modelValue": S[2] || (S[2] = (w) => n.value.account = w),
          autofocus: "",
          outlined: "",
          "no-error-icon": "",
          label: k.value,
          class: "item-input account-input",
          maxlength: "50",
          autocomplete: "username",
          rules: [I],
          onKeydown: [
            S[3] || (S[3] = ue(K((w) => i(a)(1), ["prevent"]), ["down"])),
            S[4] || (S[4] = ue(K((w) => i(a)(-1), ["prevent"]), ["up"])),
            ue(K(i(m), ["prevent"]), ["enter"])
          ]
        }, It({
          default: v(() => [
            g(i(st), {
              modelValue: i(u),
              "onUpdate:modelValue": S[1] || (S[1] = (w) => Ue(u) ? u.value = w : null),
              anchor: "bottom left",
              self: "top left",
              fit: "",
              "no-parent-event": "",
              "no-focus": "",
              offset: [0, 4],
              class: "email-menu",
              cover: !1
            }, {
              default: v(() => [
                g(i(at), { class: "email-menu__list" }, {
                  default: v(() => [
                    (x(!0), j(Be, null, ct(i(c), (w, E) => (x(), D(i(rt), {
                      key: w,
                      clickable: "",
                      dense: "",
                      active: E === i(o),
                      onMouseenter: (Z) => o.value = E,
                      onClick: (Z) => i(d)(w)
                    }, {
                      default: v(() => [
                        g(i(it), null, {
                          default: v(() => [
                            h("span", {
                              innerHTML: i(C)(w)
                            }, null, 8, ys)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 2
        }, [
          i(y) ? {
            name: "prepend",
            fn: v(() => [
              g(i(so), {
                modelValue: n.value.areaCode,
                "onUpdate:modelValue": S[0] || (S[0] = (w) => n.value.areaCode = w),
                class: "area-code-select",
                outlined: "",
                options: e.intelCodeList
              }, {
                selected: v(() => [
                  h("span", null, "+ " + N(n.value.areaCode.displayValue), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "label", "rules", "onKeydown"]),
        g(i(te), {
          loading: A.value,
          type: "submit",
          class: "mc-login__btn"
        }, {
          default: v(() => [
            oe(N(i(r)("login.form.continue")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }));
  }
}, _s = /* @__PURE__ */ le(hs, [["__scopeId", "data-v-51bb6238"]]), bs = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26422)'%3e%3cpath%20d='M43%2028C43%2019.7158%2036.2842%2013%2028%2013C19.7158%2013%2013%2019.7158%2013%2028C13%2035.0344%2017.8432%2040.9372%2024.3766%2042.5584V32.584H21.2836V28H24.3766V26.0248C24.3766%2020.9194%2026.6872%2018.553%2031.6996%2018.553C32.65%2018.553%2034.2898%2018.7396%2034.9606%2018.9256V23.0806C34.6066%2023.0434%2033.9916%2023.0248%2033.2278%2023.0248C30.7684%2023.0248%2029.818%2023.9566%2029.818%2026.3788V28H34.7176L33.8758%2032.584H29.818V42.8902C37.2454%2041.9932%2043.0006%2035.6692%2043.0006%2028H43Z'%20fill='%230866FF'/%3e%3cpath%20d='M33.8735%2032.5857L34.7153%2028.0017H29.8157V26.3805C29.8157%2023.9583%2030.7661%2023.0265%2033.2255%2023.0265C33.9893%2023.0265%2034.6043%2023.0451%2034.9583%2023.0823V18.9273C34.2875%2018.7407%2032.6477%2018.5547%2031.6973%2018.5547C26.6849%2018.5547%2024.3743%2020.9211%2024.3743%2026.0265V28.0017H21.2812V32.5857H24.3743V42.5601C25.5347%2042.8481%2026.7485%2043.0017%2027.9977%2043.0017C28.6127%2043.0017%2029.2193%2042.9639%2029.8151%2042.8919V32.5857H33.8729H33.8735Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26422'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2013)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ws = {
  __name: "index",
  setup(e) {
    const t = ye(), s = me("config");
    function n() {
      r();
    }
    async function r() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const u = await Qe({
          platForm: "SHOPIFY",
          countryCode: s.value.country || "US",
          countryName: s.value.countryName || "United States",
          redirectUrl: s.value.redirect || location.href,
          registerSource: s.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "facebook_login_redirect",
          s.value.redirect || location.href
        );
        const o = u.sid || "", c = await mt("facebook_shopify", { sid: o, redirectUri: `${location.origin}/pages/third-login-auth?channel=facebook_shopify` });
        window.location.href = c;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    async function l() {
      n();
    }
    return (u, o) => (x(), j("div", {
      class: "facebook-login",
      onClick: l
    }, [...o[0] || (o[0] = [
      h("img", {
        src: bs,
        alt: ""
      }, null, -1)
    ])]));
  }
}, Cs = /* @__PURE__ */ le(ws, [["__scopeId", "data-v-5cc7b185"]]), ks = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26410)'%3e%3cpath%20d='M28%2025.2734V31.0825H36.0727C35.7182%2032.9507%2034.6545%2034.5326%2033.059%2035.5962L37.9272%2039.3735C40.7635%2036.7554%2042.3999%2032.9099%2042.3999%2028.3418C42.3999%2027.2782%2042.3045%2026.2553%2042.1272%2025.2736L28%2025.2734Z'%20fill='%234285F4'/%3e%3cpath%20d='M19.5938%2030.8594L18.4958%2031.6998L14.6094%2034.7271C17.0776%2039.6225%2022.1363%2043.0044%2027.9999%2043.0044C32.0498%2043.0044%2035.4452%2041.668%2037.927%2039.3771L33.0589%2035.5998C31.7225%2036.4998%2030.018%2037.0453%2027.9999%2037.0453C24.0999%2037.0453%2020.7863%2034.4135%2019.5999%2030.868L19.5938%2030.8594Z'%20fill='%2334A853'/%3e%3cpath%20d='M14.609%2021.2734C13.5863%2023.2915%2013%2025.5688%2013%2027.9961C13%2030.4233%2013.5863%2032.7006%2014.609%2034.7187C14.609%2034.7323%2019.6%2030.846%2019.6%2030.846C19.3%2029.946%2019.1226%2028.9915%2019.1226%2027.9959C19.1226%2027.0003%2019.3%2026.0458%2019.6%2025.1459L14.609%2021.2734Z'%20fill='%23FBBC05'/%3e%3cpath%20d='M28.0002%2018.9727C30.2093%2018.9727%2032.1729%2019.7363%2033.7411%2021.2091L38.0365%2016.9137C35.4319%2014.4865%2032.0502%2013%2028.0002%2013C22.1366%2013%2017.0776%2016.3682%2014.6094%2021.2773L19.6002%2025.15C20.7865%2021.6045%2024.1002%2018.9727%2028.0002%2018.9727Z'%20fill='%23EA4335'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26410'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2013)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Ss = {
  __name: "index",
  props: {
    defaultRegion: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = ye(), s = me("config");
    let n = "";
    async function r() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const l = await Qe({
          platForm: "SHOPIFY",
          countryCode: s.value.country || "US",
          countryName: s.value.countryName || "United States",
          redirectUrl: s.value.redirect || location.href,
          registerSource: s.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "google_login_redirect",
          s.value.redirect || location.href
        ), n = l.sid || "";
        const u = await mt("google_shopify", { sid: n, redirectUri: `${location.origin}/pages/third-login-auth?channel=google_shopify` });
        window.location.href = u;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    return (l, u) => (x(), j("div", {
      class: "google-login",
      onClick: r
    }, [...u[0] || (u[0] = [
      h("img", {
        src: ks,
        alt: ""
      }, null, -1)
    ])]));
  }
}, Es = /* @__PURE__ */ le(Ss, [["__scopeId", "data-v-51636736"]]);
function to(e) {
  const t = V(!1);
  function s() {
    t.value || window.initGeetest4 && window.initGeetest4(
      {
        captchaId: "dfac81b336844c9273d8ab448c45c55f",
        product: "bind",
        hideSuccess: !0,
        language: "eng"
      },
      (r) => {
        t.value = r, r.onReady(() => {
        }).onSuccess(() => {
          const l = r.getValidate();
          console.log("gt4 result", l), e({
            lotNumber: l.lot_number,
            captchaOutput: l.captcha_output,
            passToken: l.pass_token,
            genTime: l.gen_time
          }), r.reset();
        }).onError(() => {
        });
      }
    );
  }
  function n() {
    t.value && t.value.showCaptcha();
  }
  return {
    initGeetest: s,
    sendGetCodeHandle: n
  };
}
const oo = `${En()}/forget_pwd`, Ts = { class: "mc-login__title" }, xs = {
  key: 0,
  class: "mc-login__description"
}, Ls = {
  key: 0,
  class: "text-btn"
}, Vs = {
  key: 0,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Is = {
  key: 1,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ps = {
  key: 3,
  class: "mc-login_switch-container"
}, $s = { class: "mc-login_setPassword" }, Rs = ["href"], Ms = {
  __name: "loginForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ ke(["step", "success"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, n = qe(e, "form"), { t: r } = ve(), l = me("config"), { remaining: u, start: o, reset: c } = Kt(0), d = V(!0), { sid: a, getInitSid: m, getVerifyCodeError: C } = yt(n), y = ge("verifyCodeRef"), b = V(""), T = V(!1);
    async function k(F = {}) {
      try {
        T.value = !0, await m(l.value.redirect || location.href);
        const _ = await zt(
          {
            scene: 2,
            sid: a.value,
            phone: n.value.account,
            type: 2
          },
          F
        );
        if (Reflect.has(_, "message")) {
          o(60), y.value.focus(), b.value = _.message || r("login.code.errorSendFail");
          return;
        }
        if (Reflect.has(_, "status")) {
          if (_.status === 11) {
            b.value = r("login.code.errorSessionExpired");
            return;
          } else if (_.status === 12) {
            b.value = r("login.code.errorIncorrect");
            return;
          }
        }
        o(60), y.value.focus();
      } finally {
        T.value = !1;
      }
    }
    function I() {
      s("step", {
        loginType: "",
        loginMethod: "",
        passwordType: "",
        code: "",
        password: "",
        realPhone: ""
      });
    }
    function A() {
      if (!n.value.code) {
        b.value = r("login.code.validateRequired");
        return;
      }
      if (n.value.code.length !== 6) {
        b.value = r("login.code.validateLength");
        return;
      }
      b.value = "";
    }
    function U() {
      if (!n.value.password)
        return r("login.password.validateRequired");
      if (n.value.password.length < 6)
        return r("login.password.validateLength");
    }
    const O = V(!1), S = V("");
    function w() {
      b.value = "", S.value = "", n.value.passwordType === "password" ? (n.value.passwordType = "code", c(), m(l.value.redirect || location.href)) : n.value.passwordType = "password";
    }
    async function E() {
      const F = {
        code: n.value.code,
        sid: a.value,
        phone: n.value.realPhone,
        loginType: 2,
        activityType: l.value.activityType
      }, _ = await Fn(F);
      if (b.value = C(_), !b.value)
        return _;
    }
    async function Z() {
      const F = {
        platForm: "SHOPIFY",
        phone: n.value.loginMethod === "phone" ? n.value.realPhone : "",
        email: n.value.loginMethod === "email" ? n.value.account : "",
        type: n.value.loginMethod === "phone" ? 2 : 1,
        subscribeNews: n.value.subscribeNews,
        password: jt(n.value.password),
        secretValue: await ze(n.value.password),
        secretType: 1,
        activityType: l.value.activityType,
        redirect: l.value.redirect || location.href
      }, _ = await Un(F);
      if (_.code === "10004013" || !_.token) {
        S.value = _.message || r("login.password.errorIncorrect");
        return;
      }
      return S.value = "", _;
    }
    async function J() {
      try {
        O.value = !0;
        let F = null;
        n.value.passwordType === "password" ? F = await Z() : F = await E(), s("success", {
          type: "login",
          email: F.email,
          token: F.token,
          shopifyLoginToken: F.shopifyLoginToken,
          userId: F.uid
        });
      } finally {
        O.value = !1;
      }
    }
    const { initGeetest: Y, sendGetCodeHandle: ee } = to(k);
    _e(() => {
      Y();
    });
    function X() {
      n.value.loginMethod === "phone" ? ee() : k();
    }
    return (F, _) => (x(), D(i(Te), {
      class: "mc-login__card",
      onSubmit: K(J, ["prevent"])
    }, {
      default: v(() => [
        h("div", Ts, N(i(l).customTitle || i(r)("login.title")), 1),
        i(l).customDescription ? (x(), j("div", xs, N(i(l).customDescription), 1)) : ae("", !0),
        g(i(ie), {
          modelValue: n.value.account,
          "onUpdate:modelValue": _[0] || (_[0] = (H) => n.value.account = H),
          outlined: "",
          readonly: "",
          class: "item-input account-input"
        }, {
          append: v(() => [
            g(i(te), {
              class: "text-btn",
              flat: "",
              "no-caps": "",
              color: "primary",
              onClick: I
            }, {
              default: v(() => [
                oe(N(i(r)("login.actions.change")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        n.value.passwordType === "code" ? (x(), D(i(ie), {
          key: 1,
          ref_key: "verifyCodeRef",
          ref: y,
          modelValue: n.value.code,
          "onUpdate:modelValue": _[1] || (_[1] = (H) => n.value.code = H),
          rules: [A],
          maxlength: "6",
          "no-error-icon": "",
          type: "text",
          label: i(r)("login.code.label"),
          class: "item-input",
          outlined: "",
          "error-message": b.value,
          error: !!b.value,
          mask: "########"
        }, {
          append: v(() => [
            i(u) > 0 ? (x(), j("span", Ls, N(i(u)), 1)) : (x(), D(i(te), {
              key: 1,
              class: "text-btn",
              loading: T.value,
              flat: "",
              "no-caps": "",
              color: "primary",
              onClick: X
            }, {
              default: v(() => [
                oe(N(i(r)("login.code.send")), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          ]),
          _: 1
        }, 8, ["modelValue", "rules", "label", "error-message", "error"])) : n.value.passwordType === "password" ? (x(), D(i(ie), {
          key: 2,
          modelValue: n.value.password,
          "onUpdate:modelValue": [
            _[3] || (_[3] = (H) => n.value.password = H),
            _[4] || (_[4] = (H) => S.value = "")
          ],
          rules: [U],
          outlined: "",
          type: d.value ? "password" : "text",
          label: i(r)("login.password.label"),
          class: "item-input",
          "no-error-icon": "",
          autocomplete: "current-password",
          "error-message": S.value,
          error: !!S.value
        }, {
          append: v(() => [
            h("div", {
              onClick: _[2] || (_[2] = (H) => d.value = !d.value)
            }, [
              d.value ? (x(), j("svg", Is, [..._[6] || (_[6] = [
                h("path", {
                  d: "M20.6523 21.2624C20.3367 21.2624 20.0289 21.1015 19.8548 20.8115L17.9992 17.7155C17.7354 17.2752 17.8786 16.7052 18.3186 16.4409C18.7586 16.1771 19.3289 16.3205 19.5926 16.7602L21.4482 19.8562C21.712 20.2965 21.5689 20.8665 21.1289 21.1309C20.9849 21.2171 20.8201 21.2626 20.6523 21.2624ZM25.6001 18.1665C25.3623 18.1665 25.1245 18.0759 24.9432 17.8943L22.4689 15.4174C22.1064 15.054 22.1067 14.4662 22.4695 14.1034C22.8323 13.7418 23.4201 13.7412 23.7829 14.104L26.2573 16.5809C26.6198 16.9443 26.6195 17.5321 26.2567 17.8949C26.1705 17.9811 26.0681 18.0495 25.9555 18.0961C25.8428 18.1427 25.722 18.1666 25.6001 18.1665ZM11.3526 21.2624C11.1901 21.2624 11.0254 21.2202 10.8761 21.1299C10.4357 20.8662 10.2932 20.2962 10.5567 19.8559L12.4123 16.7599C12.6761 16.3202 13.2464 16.1765 13.6864 16.4412C14.1267 16.7049 14.2692 17.2749 14.0057 17.7152L12.1501 20.8112C11.9761 21.1015 11.6682 21.2624 11.3526 21.2624ZM6.40512 18.1665C6.16762 18.1665 5.93012 18.0759 5.74887 17.8949C5.38605 17.5321 5.38574 16.9443 5.74824 16.5809L8.22262 14.104C8.58543 13.7412 9.17324 13.7418 9.53606 14.1034C9.89887 14.4662 9.89918 15.054 9.53668 15.4174L7.0623 17.8943C6.88074 18.0759 6.64293 18.1665 6.40512 18.1665Z",
                  fill: "black"
                }, null, -1),
                h("path", {
                  d: "M16.301 17.5478C13.7129 17.5478 9.90541 16.6612 6.46072 12.4375C6.42103 12.3884 6.39041 12.3503 6.36791 12.3244C6.02728 11.9862 5.99822 11.4378 6.31353 11.0653C6.64478 10.6734 7.23072 10.625 7.62228 10.9559C7.66166 10.989 7.7601 11.0912 7.90041 11.2631C10.8838 14.9222 14.1154 15.69 16.301 15.69C20.0726 15.69 24.3657 11.7959 24.7892 11.1772C25.0729 10.764 25.6438 10.6306 26.0673 10.9009C26.4898 11.1706 26.6342 11.7075 26.3788 12.1387C25.9395 12.88 21.1051 17.5478 16.301 17.5478Z",
                  fill: "black"
                }, null, -1)
              ])])) : (x(), j("svg", Vs, [..._[5] || (_[5] = [
                h("path", {
                  d: "M15.9975 26C11.1085 26 6.74683 22.9147 2.92217 16.8873C2.75359 16.6221 2.66406 16.3143 2.66406 16C2.66406 15.6857 2.75359 15.3779 2.92217 15.1127C6.74683 9.08533 11.1085 6 15.9975 6C20.8865 6 25.2482 9.08533 29.0728 15.1127C29.2414 15.3779 29.3309 15.6857 29.3309 16C29.3309 16.3143 29.2414 16.6221 29.0728 16.8873C25.2482 22.9147 20.8865 26 15.9975 26ZM15.9975 8C11.9502 8 8.20183 10.6203 4.74383 16C8.20183 21.3797 11.9502 24 15.9975 24C20.0448 24 23.7932 21.3797 27.2512 16C23.7932 10.6203 20.0448 8 15.9975 8ZM15.9975 20.6667C13.3972 20.6667 11.2892 18.5773 11.2892 16C11.2892 13.4227 13.3972 11.3333 15.9975 11.3333C18.5978 11.3333 20.7058 13.4227 20.7058 16C20.7058 18.5773 18.5978 20.6667 15.9975 20.6667ZM15.9975 18.6667C17.4835 18.6667 18.6882 17.4727 18.6882 16C18.6882 14.5273 17.4835 13.3333 15.9975 13.3333C14.5115 13.3333 13.3068 14.5273 13.3068 16C13.3068 17.4727 14.5115 18.6667 15.9975 18.6667Z",
                  fill: "black"
                }, null, -1)
              ])]))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "rules", "type", "label", "error-message", "error"])) : ae("", !0),
        n.value.loginMethod === "phone" ? (x(), j("div", Ps, [
          h("button", {
            type: "button",
            class: "mc-login_switch",
            onClick: w
          }, N(n.value.passwordType === "password" ? i(r)("login.switch.codeLogin") : i(r)("login.switch.passwordLogin")), 1)
        ])) : ae("", !0),
        g(i(te), {
          loading: O.value,
          type: "submit",
          class: "mc-login__btn"
        }, {
          default: v(() => [
            oe(N(i(r)("login.actions.signIn")), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        h("div", $s, [
          h("a", {
            href: i(oo),
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": "forget password (opens in a new tab)",
            "aria-describedby": "a11y-new-window-message"
          }, N(i(r)("login.actions.forgotPassword")), 9, Rs)
        ])
      ]),
      _: 1
    }));
  }
}, Os = /* @__PURE__ */ le(Ms, [["__scopeId", "data-v-126fa98e"]]), Ns = { class: "mc-login__container register-container" }, As = { class: "title" }, Us = ["innerHTML"], Fs = {
  key: 0,
  class: "text-btn"
}, qs = {
  __name: "verifyEmailWhenPhone",
  props: {
    data: {
      type: Object
    },
    registerInfo: {
      type: Object,
      required: !0
    }
  },
  emits: ["success"],
  setup(e, { expose: t, emit: s }) {
    const n = e, r = s, l = me("config", {}), u = vt(l), { t: o } = ve(), c = V(!1), d = V({
      account: "",
      code: "",
      areaCode: n.data.areaCode
    }), {
      suggestionMenu: a,
      activeSuggestionIndex: m,
      computedEmailOptions: C,
      selectEmailOption: y,
      moveSuggestion: b,
      applyActiveSuggestion: T,
      highlightSuggestion: k
    } = gt(d);
    function I() {
      if (!d.value.account)
        return o("login.form.validateEmailRequired");
      if (!pt.test(d.value.account))
        return o("login.form.validateEmail");
    }
    const A = ge("verifyCodeRef"), U = V("");
    function O() {
      if (!d.value.code) {
        U.value = o("login.code.validateRequired");
        return;
      }
      if (d.value.code.length !== 6) {
        U.value = o("login.code.validateLength");
        return;
      }
      U.value = "";
    }
    const {
      sid: S,
      verifyCodeSending: w,
      remaining: E,
      start: Z,
      sendVerificationCode: J,
      getVerifyCodeError: Y
    } = yt(d);
    async function ee() {
      try {
        w.value = !0;
        const H = {
          scene: 1,
          sid: S.value,
          email: d.value.account,
          type: 1
        };
        await J(H), d.value.code = "", U.value = "", Re(() => A.value.resetValidation()), Z(60), A.value.focus();
      } catch (H) {
        H instanceof we ? U.value = H.message : U.value = o("login.common.unknownError");
      } finally {
        w.value = !1;
      }
    }
    const X = V(!1);
    async function F() {
      try {
        await Se({
          eventName: "register_submit",
          content: {
            ...u.value
          }
        }), X.value = !0;
        const H = {
          registerType: 2,
          subscribeNews: n.data.subscribeNews,
          firstName: "",
          lastName: "",
          phone: n.data.account,
          email: d.value.account,
          secretValue: await ze(n.data.password),
          secretType: 1,
          babyBirthday: n.data.babyBirthday,
          sid: S.value,
          code: d.value.code,
          ...n.registerInfo
        }, P = await Qt(H);
        if (U.value = Y(P), X.value = !1, U.value)
          return;
        r("success", {
          type: "register",
          email: P.email,
          token: P.token,
          shopifyLoginToken: P.shopifyLoginToken,
          userId: P.uid
        });
      } catch {
        U.value = o("login.common.unknownError");
      }
    }
    function _() {
      c.value = !1;
    }
    return t({
      open() {
        c.value = !0;
      }
    }), (H, P) => (x(), D(i($e), {
      modelValue: c.value,
      "onUpdate:modelValue": P[5] || (P[5] = (B) => c.value = B),
      class: "mc-login nt",
      persistent: ""
    }, {
      default: v(() => [
        h("div", Ns, [
          g(i(te), {
            class: "mc-close-icon",
            icon: "close",
            flat: "",
            round: "",
            dense: "",
            onClick: _
          }),
          h("div", As, N(i(o)("login.phoneRegisterTitle")), 1),
          g(i(Te), { onSubmit: F }, {
            default: v(() => [
              g(i(ie), {
                modelValue: d.value.account,
                "onUpdate:modelValue": P[1] || (P[1] = (B) => d.value.account = B),
                rules: [I],
                label: i(o)("login.form.labelEmail"),
                outlined: "",
                autofocus: "",
                "no-error-icon": "",
                class: "item-input account-input",
                maxlength: "50",
                autocomplete: "username",
                onKeydown: [
                  P[2] || (P[2] = ue(K((B) => i(b)(1), ["prevent"]), ["down"])),
                  P[3] || (P[3] = ue(K((B) => i(b)(-1), ["prevent"]), ["up"])),
                  ue(K(i(T), ["prevent"]), ["enter"])
                ]
              }, {
                default: v(() => [
                  g(i(st), {
                    modelValue: i(a),
                    "onUpdate:modelValue": P[0] || (P[0] = (B) => Ue(a) ? a.value = B : null),
                    anchor: "bottom left",
                    self: "top left",
                    fit: "",
                    "no-parent-event": "",
                    "no-focus": "",
                    offset: [0, 4],
                    class: "email-menu",
                    cover: !1
                  }, {
                    default: v(() => [
                      g(i(at), { class: "email-menu__list" }, {
                        default: v(() => [
                          (x(!0), j(Be, null, ct(i(C), (B, re) => (x(), D(i(rt), {
                            key: B,
                            clickable: "",
                            dense: "",
                            active: re === i(m),
                            onMouseenter: (he) => m.value = re,
                            onClick: (he) => i(y)(B)
                          }, {
                            default: v(() => [
                              g(i(it), null, {
                                default: v(() => [
                                  h("span", {
                                    innerHTML: i(k)(B)
                                  }, null, 8, Us)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "label", "onKeydown"]),
              g(i(ie), {
                ref_key: "verifyCodeRef",
                ref: A,
                modelValue: d.value.code,
                "onUpdate:modelValue": P[4] || (P[4] = (B) => d.value.code = B),
                rules: [O],
                maxlength: "6",
                "no-error-icon": "",
                type: "text",
                label: i(o)("login.code.label"),
                class: "item-input",
                outlined: "",
                "error-message": U.value,
                error: !!U.value,
                autocomplete: "one-time-code",
                mask: "########"
              }, {
                append: v(() => [
                  i(E) > 0 ? (x(), j("span", Fs, N(i(E)), 1)) : (x(), D(i(te), {
                    key: 1,
                    class: "text-btn",
                    loading: i(w),
                    flat: "",
                    "no-caps": "",
                    color: "primary",
                    onClick: ee
                  }, {
                    default: v(() => [
                      oe(N(i(o)("login.code.send")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "label", "error-message", "error"]),
              g(i(te), {
                type: "submit",
                loading: X.value,
                class: "mc-login__btn"
              }, {
                default: v(() => [
                  oe(N(i(o)("login.common.confirm")), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}, Bs = /* @__PURE__ */ le(qs, [["__scopeId", "data-v-1ae47050"]]), Ds = { class: "mc-register-login__title" }, Hs = {
  key: 0,
  class: "text-btn"
}, js = {
  key: 0,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gs = {
  key: 1,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zs = { class: "row items-center justify-end" }, zs = { class: "mc-register__terms" }, Qs = ["href"], Ys = {
  __name: "registerForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ ke(["step", "success"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, n = ye(), r = Tt, l = me("config", {}), { t: u } = ve(), o = qe(e, "form"), c = eo(l), d = vt(l), { trackSubscribeView: a, trackSubscribeClick: m, trackSubscribeFail: C } = us(l), y = ge("subscribeCheckboxRef"), b = () => o.value.loginMethod === "email";
    _e(() => {
      Re(() => {
        b() && y.value?.$el && a(y.value.$el, o.value.subscribeNews === 1);
      });
    });
    const T = ge("verifyCodeRef"), k = V(""), {
      sid: I,
      verifyCodeSending: A,
      remaining: U,
      start: O,
      sendVerificationCode: S,
      getVerifyCodeError: w,
      getInitSid: E
    } = yt(o);
    async function Z(G = {}) {
      try {
        A.value = !0, await E(c.value.redirect);
        const M = {
          scene: 1,
          sid: I.value,
          phone: o.value.loginMethod === "phone" ? o.value.realPhone : "",
          email: o.value.loginMethod === "email" ? o.value.account : "",
          type: o.value.loginMethod === "phone" ? 2 : 1
        };
        await S(M, G), o.value.code = "", k.value = "", Re(() => {
          T.value.resetValidation();
        }), O(60), T.value.focus();
      } catch (M) {
        O(60), T.value.focus(), M instanceof we ? k.value = M.message : k.value = u("login.common.unknownError");
      } finally {
        A.value = !1;
      }
    }
    function J() {
      s("step", {
        loginType: "",
        loginMethod: "",
        code: "",
        password: "",
        realPhone: ""
      });
    }
    function Y() {
      if (!o.value.code) {
        k.value = u("login.code.validateRequired");
        return;
      }
      if (o.value.code.length !== 6) {
        k.value = u("login.code.validateLength");
        return;
      }
      k.value = "";
    }
    const ee = V(!0);
    function X() {
      if (!o.value.password)
        return u("login.password.validateRequired");
      if (o.value.password.length < 6)
        return u("login.password.validateLength");
    }
    const F = /^(?:\d{3}[1-9]|\d{2}[1-9]\d|\d[1-9]\d{2}|[1-9]\d{3})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-8]))|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[3579][26])00)-02-29$/;
    function _() {
      if (!o.value.babyBirthday)
        return u("login.birthday.validateRequired_html");
      if (!F.test(o.value.babyBirthday))
        return u("login.birthday.validateInvalid_html");
    }
    const H = ge("verifyEmailWhenPhoneRef"), P = V(!1);
    async function B() {
      const G = {
        phone: o.value.account,
        code: o.value.code,
        sid: I.value,
        scene: 1,
        type: 2
      }, M = await Bn(G);
      k.value = w(M), !k.value && H.value.open();
    }
    async function re() {
      try {
        await Se({
          eventName: "register_submit",
          content: {
            ...d.value
          }
        });
        const G = b() ? await m({
          email_input_state: (o.value.account || "").trim() === "" ? "empty" : /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/.test((o.value.account || "").trim()) ? "valid" : "invalid",
          consent_state: o.value.subscribeNews === 1
        }) : "", M = {
          registerType: 1,
          subscribeNews: o.value.subscribeNews,
          firstName: "",
          lastName: "",
          email: o.value.account,
          secretValue: await ze(o.value.password),
          secretType: 1,
          babyBirthday: o.value.babyBirthday,
          sid: I.value,
          code: o.value.code,
          ...c.value,
          // 勾选订阅时把 request_id 透传后端，供 email_subscribe_submit_success 关联
          ...o.value.subscribeNews === 1 ? { subscribe_request_id: G } : {}
        }, se = await Qt(M);
        if (k.value = w(se), k.value) {
          b() && C({
            request_id: G,
            failure_stage: "api_request",
            error_code: k.value,
            error_type: "register_failed",
            retryable: !0
          });
          return;
        }
        s("success", {
          type: "register",
          email: se.email,
          token: se.token,
          shopifyLoginToken: se.shopifyLoginToken,
          userId: se.uid
        });
      } catch {
        k.value = u("login.common.unknownError");
      }
    }
    const he = ge("policyRef");
    function Xe(G) {
      G.animate(
        {
          transform: [
            "translateX(0)",
            "translateX(-32px)",
            "translateX(32px)",
            "translateX(-16px)",
            "translateX(16px)",
            "translateX(-8px)",
            "translateX(8px)",
            "translateX(-4px)",
            "translateX(4px)",
            "translateX(-2px)",
            "translateX(2px)",
            "translateX(0)"
          ]
        },
        {
          duration: 1e3,
          easing: "cubic-bezier(.36, .07, .19, .97)",
          fill: "forwards"
        }
      );
    }
    const f = V(!1);
    function $() {
      f.value = !0, Xe(he.value);
    }
    function p(G) {
      s("success", G);
    }
    function L() {
      return o.value.agreePolicy ? !0 : (n.notify({
        message: u("login.terms.policyTip_html"),
        position: "center",
        classes: "mc-notify--policy",
        multiLine: !0,
        html: !0,
        timeout: 2e3
      }), !1);
    }
    async function R() {
      try {
        if (!L()) {
          $();
          return;
        }
        P.value = !0, o.value.loginMethod === "phone" ? await B() : await re();
      } finally {
        P.value = !1;
      }
    }
    const { initGeetest: q, sendGetCodeHandle: ne } = to(Z);
    _e(() => {
      q();
    });
    function ce() {
      o.value.loginMethod === "phone" ? ne() : Z();
    }
    return (G, M) => {
      const se = W("i18n-t");
      return x(), D(i(Te), {
        class: "mc-login__card",
        onSubmit: K(R, ["prevent"])
      }, {
        default: v(() => [
          h("div", Ds, N(i(u)("login.title")), 1),
          g(i(ie), {
            modelValue: o.value.account,
            "onUpdate:modelValue": M[0] || (M[0] = (z) => o.value.account = z),
            outlined: "",
            readonly: "",
            class: "item-input account-input"
          }, {
            append: v(() => [
              g(i(te), {
                class: "text-btn",
                flat: "",
                "no-caps": "",
                color: "primary",
                onClick: J
              }, {
                default: v(() => [
                  oe(N(i(u)("login.actions.change")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          g(i(ie), {
            ref_key: "verifyCodeRef",
            ref: T,
            modelValue: o.value.code,
            "onUpdate:modelValue": M[1] || (M[1] = (z) => o.value.code = z),
            rules: [Y],
            maxlength: "6",
            "no-error-icon": "",
            type: "text",
            label: i(u)("login.code.label"),
            class: "item-input",
            outlined: "",
            "error-message": k.value,
            error: !!k.value,
            autocomplete: "one-time-code",
            mask: "########"
          }, {
            append: v(() => [
              i(U) > 0 ? (x(), j("span", Hs, N(i(U)), 1)) : (x(), D(i(te), {
                key: 1,
                class: "text-btn",
                loading: i(A),
                flat: "",
                "no-caps": "",
                color: "primary",
                onClick: ce
              }, {
                default: v(() => [
                  oe(N(i(u)("login.code.send")), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "error-message", "error"]),
          g(i(ie), {
            modelValue: o.value.password,
            "onUpdate:modelValue": M[3] || (M[3] = (z) => o.value.password = z),
            rules: [X],
            outlined: "",
            type: ee.value ? "password" : "text",
            label: i(u)("login.password.label"),
            class: "item-input",
            "no-error-icon": "",
            autocomplete: "current-password"
          }, {
            append: v(() => [
              h("div", {
                onClick: M[2] || (M[2] = (z) => ee.value = !ee.value)
              }, [
                ee.value ? (x(), j("svg", Gs, [...M[12] || (M[12] = [
                  h("path", {
                    d: "M20.6523 21.2624C20.3367 21.2624 20.0289 21.1015 19.8548 20.8115L17.9992 17.7155C17.7354 17.2752 17.8786 16.7052 18.3186 16.4409C18.7586 16.1771 19.3289 16.3205 19.5926 16.7602L21.4482 19.8562C21.712 20.2965 21.5689 20.8665 21.1289 21.1309C20.9849 21.2171 20.8201 21.2626 20.6523 21.2624ZM25.6001 18.1665C25.3623 18.1665 25.1245 18.0759 24.9432 17.8943L22.4689 15.4174C22.1064 15.054 22.1067 14.4662 22.4695 14.1034C22.8323 13.7418 23.4201 13.7412 23.7829 14.104L26.2573 16.5809C26.6198 16.9443 26.6195 17.5321 26.2567 17.8949C26.1705 17.9811 26.0681 18.0495 25.9555 18.0961C25.8428 18.1427 25.722 18.1666 25.6001 18.1665ZM11.3526 21.2624C11.1901 21.2624 11.0254 21.2202 10.8761 21.1299C10.4357 20.8662 10.2932 20.2962 10.5567 19.8559L12.4123 16.7599C12.6761 16.3202 13.2464 16.1765 13.6864 16.4412C14.1267 16.7049 14.2692 17.2749 14.0057 17.7152L12.1501 20.8112C11.9761 21.1015 11.6682 21.2624 11.3526 21.2624ZM6.40512 18.1665C6.16762 18.1665 5.93012 18.0759 5.74887 17.8949C5.38605 17.5321 5.38574 16.9443 5.74824 16.5809L8.22262 14.104C8.58543 13.7412 9.17324 13.7418 9.53606 14.1034C9.89887 14.4662 9.89918 15.054 9.53668 15.4174L7.0623 17.8943C6.88074 18.0759 6.64293 18.1665 6.40512 18.1665Z",
                    fill: "black"
                  }, null, -1),
                  h("path", {
                    d: "M16.301 17.5478C13.7129 17.5478 9.90541 16.6612 6.46072 12.4375C6.42103 12.3884 6.39041 12.3503 6.36791 12.3244C6.02728 11.9862 5.99822 11.4378 6.31353 11.0653C6.64478 10.6734 7.23072 10.625 7.62228 10.9559C7.66166 10.989 7.7601 11.0912 7.90041 11.2631C10.8838 14.9222 14.1154 15.69 16.301 15.69C20.0726 15.69 24.3657 11.7959 24.7892 11.1772C25.0729 10.764 25.6438 10.6306 26.0673 10.9009C26.4898 11.1706 26.6342 11.7075 26.3788 12.1387C25.9395 12.88 21.1051 17.5478 16.301 17.5478Z",
                    fill: "black"
                  }, null, -1)
                ])])) : (x(), j("svg", js, [...M[11] || (M[11] = [
                  h("path", {
                    d: "M15.9975 26C11.1085 26 6.74683 22.9147 2.92217 16.8873C2.75359 16.6221 2.66406 16.3143 2.66406 16C2.66406 15.6857 2.75359 15.3779 2.92217 15.1127C6.74683 9.08533 11.1085 6 15.9975 6C20.8865 6 25.2482 9.08533 29.0728 15.1127C29.2414 15.3779 29.3309 15.6857 29.3309 16C29.3309 16.3143 29.2414 16.6221 29.0728 16.8873C25.2482 22.9147 20.8865 26 15.9975 26ZM15.9975 8C11.9502 8 8.20183 10.6203 4.74383 16C8.20183 21.3797 11.9502 24 15.9975 24C20.0448 24 23.7932 21.3797 27.2512 16C23.7932 10.6203 20.0448 8 15.9975 8ZM15.9975 20.6667C13.3972 20.6667 11.2892 18.5773 11.2892 16C11.2892 13.4227 13.3972 11.3333 15.9975 11.3333C18.5978 11.3333 20.7058 13.4227 20.7058 16C20.7058 18.5773 18.5978 20.6667 15.9975 20.6667ZM15.9975 18.6667C17.4835 18.6667 18.6882 17.4727 18.6882 16C18.6882 14.5273 17.4835 13.3333 15.9975 13.3333C14.5115 13.3333 13.3068 14.5273 13.3068 16C13.3068 17.4727 14.5115 18.6667 15.9975 18.6667Z",
                    fill: "black"
                  }, null, -1)
                ])]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "type", "label"]),
          g(i(ie), {
            modelValue: o.value.babyBirthday,
            "onUpdate:modelValue": M[5] || (M[5] = (z) => o.value.babyBirthday = z),
            class: "item-input",
            outlined: "",
            rules: [_],
            label: i(u)("login.birthday.label_html"),
            placeholder: i(u)("login.birthday.placeholder_html"),
            "no-error-icon": "",
            mask: "####-##-##"
          }, {
            append: v(() => [
              g(i(xt), {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: v(() => [
              g(i(St), {
                class: "nt",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: v(() => [
                  g(i(Et), {
                    modelValue: o.value.babyBirthday,
                    "onUpdate:modelValue": M[4] || (M[4] = (z) => o.value.babyBirthday = z),
                    mask: "YYYY-MM-DD"
                  }, {
                    default: v(() => [
                      h("div", Zs, [
                        De(g(i(te), {
                          label: i(u)("login.common.close"),
                          color: "primary",
                          flat: ""
                        }, null, 8, ["label"]), [
                          [i(r)]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "placeholder"]),
          g(i(te), {
            type: "submit",
            loading: P.value,
            class: "mc-login__btn"
          }, {
            default: v(() => [
              oe(N(i(u)("login.actions.createAccount")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          h("div", zs, [
            h("div", {
              ref_key: "policyRef",
              ref: he
            }, [
              g(i(be), {
                modelValue: o.value.agreePolicy,
                "onUpdate:modelValue": M[8] || (M[8] = (z) => o.value.agreePolicy = z),
                size: "sm",
                class: He(["item-subscribe", f.value && !o.value.agreePolicy && "error-msg"]),
                "true-value": 1,
                "false-value": 0
              }, {
                default: v(() => [
                  g(se, {
                    keypath: "login.terms.policyInfo",
                    class: "policy-info",
                    tag: "span"
                  }, {
                    privacy: v(() => [
                      h("a", {
                        href: `${i(Gt)}?countryCode=${i(l).country}&client=1&isShowCountry=hide`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Privacy Policy (opens in a new tab)",
                        "aria-describedby": "a11y-new-window-external-message",
                        onClick: M[6] || (M[6] = K(() => {
                        }, ["stop"]))
                      }, N(G.$t("login.terms.privacy")), 9, Qs)
                    ]),
                    terms: v(() => [
                      h("a", {
                        href: "/pages/terms-conditions",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Terms & Conditions (opens in a new tab)",
                        "aria-describedby": "a11y-new-window-message",
                        onClick: M[7] || (M[7] = K(() => {
                        }, ["stop"]))
                      }, N(G.$t("login.terms.terms_html")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "class"])
            ], 512)
          ]),
          o.value.loginMethod === "phone" ? (x(), D(i(be), {
            key: 0,
            modelValue: o.value.subscribeNews,
            "onUpdate:modelValue": M[9] || (M[9] = (z) => o.value.subscribeNews = z),
            size: "sm",
            class: "item-subscribe",
            label: i(u)("login.newsletter.labelPhone"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"])) : (x(), D(i(be), {
            key: 1,
            ref_key: "subscribeCheckboxRef",
            ref: y,
            modelValue: o.value.subscribeNews,
            "onUpdate:modelValue": M[10] || (M[10] = (z) => o.value.subscribeNews = z),
            size: "sm",
            class: "item-subscribe",
            label: i(u)("login.newsletter.labelEmail"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"])),
          g(Bs, {
            ref_key: "verifyEmailWhenPhoneRef",
            ref: H,
            data: o.value,
            "register-info": i(c),
            onSuccess: p
          }, null, 8, ["data", "register-info"])
        ]),
        _: 1
      });
    };
  }
}, Xs = /* @__PURE__ */ le(Ys, [["__scopeId", "data-v-4cdbc715"]]), Ws = { class: "mc-login__container" }, Ks = { class: "divide-line" }, Js = { class: "third-content" }, ea = {
  key: 0,
  class: "mc-login__footer"
}, ta = {
  __name: "login",
  props: {
    country: { type: String, default: "US" },
    countryName: { type: String, default: "United States" },
    activityType: { type: String },
    mustAgreeEmail: { type: Boolean, default: !1 },
    loginSubscribeNews: { type: Boolean, default: !1 },
    redirect: { type: String }
  },
  setup(e, { expose: t }) {
    const s = e, n = V({
      ...s
    });
    Pt("config", n);
    const { t: r } = ve(), l = vt(n), u = V(!1), o = [
      {
        label: r("login.country.us"),
        value: "US",
        name: "United States",
        displayValue: "1"
      },
      {
        label: r("login.country.ca"),
        value: "CA",
        name: "Canada",
        displayValue: "1"
      }
    ], c = V({
      account: "",
      password: "",
      code: "",
      babyBirthday: "",
      subscribeNews: 0,
      agreePolicy: 0,
      areaCode: o[0],
      loginType: "",
      // login, register
      loginMethod: "",
      // email, phone
      passwordType: "password",
      // password, code
      countryCode: n.value.country,
      countryName: n.value.countryName
    });
    function d(T) {
      const k = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/;
      c.value.account && !k.test(c.value.account) && (c.value.account = ""), c.value = {
        ...c.value,
        ...T
      };
    }
    async function a(T) {
      T.type === "register" ? await Se({
        eventName: "register_success",
        userId: T.userId,
        content: {
          ...l.value
        }
      }) : T.type === "login" && await Se({
        eventName: "login_success",
        userId: T.userId,
        entryPage: window.location.href,
        content: {
          ...l.value
        }
      }), dt(T.token), location.href = T.shopifyLoginToken, b(!0);
    }
    const { handleCheck: m } = Yt(c, n);
    async function C(T = {}, k = {}) {
      if (c.value = { ...c.value, ...T }, n.value = { ...s, ...k }, c.value.account && k.checkImmediately) {
        const I = await m();
        d(I);
      }
      u.value = !0;
    }
    function y() {
      n.value.footerButton && typeof n.value.footerButton.onClick == "function" && n.value.footerButton.onClick();
    }
    function b(T = !1) {
      if (n.value.persistent && !T) {
        document.dispatchEvent(new Pn());
        return;
      }
      u.value = !1, document.dispatchEvent(new $n());
    }
    return _e(async () => {
      document.addEventListener("LUTE:AUTH:EXPIRED", () => {
        Nt();
      });
      const T = Ze();
      if (T) {
        const k = await Zt();
        k && k.email && (window.__MOMCOZY_USER_INFO__ = {
          email: k.email,
          token: T
        }, document.body.classList.add("momcozy-logined"), document.dispatchEvent(
          new In({
            type: "keep",
            email: k.email,
            token: T
          })
        ));
      }
    }), t({
      close: b,
      open: C
    }), (T, k) => (x(), D(i($e), $t({
      modelValue: u.value,
      "onUpdate:modelValue": k[4] || (k[4] = (I) => u.value = I),
      class: "mc-login nt"
    }, n.value, {
      onShake: k[5] || (k[5] = (I) => b(!1))
    }), {
      default: v(() => [
        h("div", Ws, [
          g(Rt, {
            name: "form",
            tag: "div",
            class: "mc-login__forms"
          }, {
            default: v(() => [
              c.value.loginType ? c.value.loginType === "login" ? (x(), D(Os, {
                key: "login",
                form: c.value,
                "onUpdate:form": k[1] || (k[1] = (I) => c.value = I),
                class: "login-form",
                onStep: d,
                onSuccess: a
              }, null, 8, ["form"])) : c.value.loginType === "register" ? (x(), D(Xs, {
                key: "register",
                form: c.value,
                "onUpdate:form": k[2] || (k[2] = (I) => c.value = I),
                class: "register-form",
                onStep: d,
                onSuccess: a
              }, null, 8, ["form"])) : ae("", !0) : (x(), D(_s, {
                key: "check",
                form: c.value,
                "onUpdate:form": k[0] || (k[0] = (I) => c.value = I),
                class: "check-form",
                "intel-code-list": o,
                onStep: d
              }, null, 8, ["form"]))
            ]),
            _: 1
          }),
          h("p", Ks, [
            h("span", null, N(i(r)("login.or")), 1)
          ]),
          h("div", Js, [
            g(Es),
            g(Cs),
            g(ms)
          ]),
          n.value.footerButton && n.value.footerButton.text ? (x(), j("div", ea, [
            h("button", {
              class: "mc-login__footer-btn",
              type: "button",
              onClick: y
            }, N(n.value.footerButton.text), 1)
          ])) : ae("", !0),
          g(i(te), {
            class: "mc-close-icon",
            icon: "close",
            flat: "",
            round: "",
            dense: "",
            onClick: k[3] || (k[3] = (I) => b(!1))
          })
        ])
      ]),
      _: 1
    }, 16, ["modelValue"]));
  }
}, oa = /* @__PURE__ */ le(ta, [["__scopeId", "data-v-54e5d7e1"]]), na = "data:image/svg+xml,%3csvg%20width='26'%20height='26'%20viewBox='0%200%2026%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='13'%20cy='13'%20r='11.2'%20stroke='%236FC177'%20stroke-width='1.6'/%3e%3cg%20clip-path='url(%23clip0_1602_999)'%3e%3cpath%20d='M8.19077%2012.5013L10.9966%2014.7369L17.9831%208.30061C17.9831%208.30061%2018.4518%207.8727%2018.8613%208.20704C18.9829%208.30701%2019.1236%208.59175%2018.8069%209.03807L11.5125%2017.5826C11.5125%2017.5826%2010.9534%2018.3481%2010.2895%2017.5746L7.14141%2013.3243C7.14141%2013.3243%206.76788%2012.7485%207.23498%2012.4037C7.39334%2012.2886%207.75167%2012.1078%208.19077%2012.5013Z'%20fill='%236FC177'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1602_999'%3e%3crect%20width='12'%20height='12'%20fill='white'%20transform='translate(7%207)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", sa = ["innerHTML"], aa = { class: "row items-center justify-end" }, ra = ["href"], ia = {
  __name: "quickRegisterForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ ke(["step", "success", "close"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, n = ye(), r = Tt, l = me("config", {}), { t: u } = ve(), o = qe(e, "form");
    o.value && (o.value.protocol = 0);
    const {
      suggestionMenu: c,
      activeSuggestionIndex: d,
      computedEmailOptions: a,
      selectEmailOption: m,
      moveSuggestion: C,
      applyActiveSuggestion: y,
      highlightSuggestion: b
    } = gt(o), T = de(() => u("login.form.labelEmail"));
    function k() {
      if (!o.value.account || !pt.test(o.value.account))
        return u("login.form.validateEmailRequired");
    }
    const I = eo(l);
    function A() {
      s("close");
    }
    const U = /^(?:\d{3}[1-9]|\d{2}[1-9]\d|\d[1-9]\d{2}|[1-9]\d{3})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-8]))|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[3579][26])00)-02-29$/;
    function O() {
      if (!o.value.babyBirthday)
        return u("login.birthday.validateRequired_html");
      if (!U.test(o.value.babyBirthday))
        return u("login.birthday.validateInvalid_html");
    }
    const S = V(!1);
    async function w() {
      try {
        const F = {
          subscribeNews: o.value.subscribeNews,
          // 订阅
          email: o.value.account,
          // 邮箱
          currentStageValue: o.value.babyBirthday,
          // 预产期
          agreePrivacyCountryCode: l.value.country,
          ...I.value,
          source: I.value.registerSource || ""
        };
        delete F.registerSource;
        const _ = await Gn(F);
        _.isRegister === 1 ? s("success", {
          type: "register",
          status: "success",
          message: _.message
        }) : _.code === "10004007" ? s("success", {
          type: "register",
          status: "notActivated",
          message: _.message
        }) : _.code === "10004050" ? s("success", {
          type: "register",
          status: "activated",
          message: _.message
        }) : n.notify({
          message: _.message,
          color: "negative",
          position: "top",
          timeout: 3e3
        });
      } catch {
        console.log("服务错误！");
      }
    }
    const E = ge("termsRef"), Z = V(!1);
    function J() {
      Z.value = !0, Y(E.value);
    }
    function Y(F) {
      F.animate(
        {
          transform: [
            "translateX(0)",
            "translateX(-32px)",
            "translateX(32px)",
            "translateX(-16px)",
            "translateX(16px)",
            "translateX(-8px)",
            "translateX(8px)",
            "translateX(-4px)",
            "translateX(4px)",
            "translateX(-2px)",
            "translateX(2px)",
            "translateX(0)"
          ]
        },
        {
          duration: 1e3,
          easing: "cubic-bezier(.36, .07, .19, .97)",
          fill: "forwards"
        }
      );
    }
    function ee() {
      return o.value.protocol ? !0 : (n.notify({
        message: u("login.terms.policyTip_html"),
        position: "center",
        classes: "mc-notify--policy",
        multiLine: !0,
        html: !0,
        timeout: 2e3
      }), !1);
    }
    async function X() {
      try {
        if (!ee()) {
          J();
          return;
        }
        S.value = !0, await w();
      } finally {
        S.value = !1;
      }
    }
    return (F, _) => {
      const H = W("i18n-t");
      return x(), D(i(Te), {
        class: "mc-login__card",
        onSubmit: K(X, ["prevent"])
      }, {
        default: v(() => [
          _[10] || (_[10] = h("div", { class: "mc-register-login__title" }, " Email Registration ", -1)),
          g(i(ie), {
            modelValue: o.value.account,
            "onUpdate:modelValue": _[1] || (_[1] = (P) => o.value.account = P),
            autofocus: "",
            outlined: "",
            "no-error-icon": "",
            label: T.value,
            class: "item-input account-input",
            maxlength: "50",
            autocomplete: "username",
            rules: [k],
            onKeydown: [
              _[2] || (_[2] = ue(K((P) => i(C)(1), ["prevent"]), ["down"])),
              _[3] || (_[3] = ue(K((P) => i(C)(-1), ["prevent"]), ["up"])),
              ue(K(i(y), ["prevent"]), ["enter"])
            ]
          }, {
            default: v(() => [
              g(i(st), {
                modelValue: i(c),
                "onUpdate:modelValue": _[0] || (_[0] = (P) => Ue(c) ? c.value = P : null),
                anchor: "bottom left",
                self: "top left",
                fit: "",
                "no-parent-event": "",
                "no-focus": "",
                offset: [0, 4],
                class: "email-menu",
                cover: !1
              }, {
                default: v(() => [
                  g(i(at), { class: "email-menu__list" }, {
                    default: v(() => [
                      (x(!0), j(Be, null, ct(i(a), (P, B) => (x(), D(i(rt), {
                        key: P,
                        clickable: "",
                        dense: "",
                        active: B === i(d),
                        onMouseenter: (re) => d.value = B,
                        onClick: (re) => i(m)(P)
                      }, {
                        default: v(() => [
                          g(i(it), null, {
                            default: v(() => [
                              h("span", {
                                innerHTML: i(b)(P)
                              }, null, 8, sa)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "rules", "onKeydown"]),
          g(i(ie), {
            modelValue: o.value.babyBirthday,
            "onUpdate:modelValue": _[5] || (_[5] = (P) => o.value.babyBirthday = P),
            class: "item-input",
            outlined: "",
            rules: [O],
            label: i(u)("login.birthday.label_html"),
            placeholder: i(u)("login.birthday.placeholder_html"),
            "no-error-icon": "",
            mask: "####-##-##"
          }, {
            append: v(() => [
              g(i(xt), {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: v(() => [
              g(i(St), {
                class: "nt",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: v(() => [
                  g(i(Et), {
                    modelValue: o.value.babyBirthday,
                    "onUpdate:modelValue": _[4] || (_[4] = (P) => o.value.babyBirthday = P),
                    mask: "YYYY-MM-DD"
                  }, {
                    default: v(() => [
                      h("div", aa, [
                        De(g(i(te), {
                          label: i(u)("login.common.close"),
                          color: "primary",
                          flat: ""
                        }, null, 8, ["label"]), [
                          [i(r)]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "placeholder"]),
          g(i(te), {
            type: "submit",
            loading: S.value,
            class: "mc-login__btn"
          }, {
            default: v(() => [
              oe(N(i(u)("login.actions.createAccount")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          h("div", {
            ref_key: "termsRef",
            ref: E,
            class: "mc-register__terms"
          }, [
            g(i(be), {
              modelValue: o.value.protocol,
              "onUpdate:modelValue": _[8] || (_[8] = (P) => o.value.protocol = P),
              size: "sm",
              class: He(["item-subscribe", Z.value && !o.value.protocol && "error-msg"]),
              "true-value": 1,
              "false-value": 0
            }, {
              default: v(() => [
                g(H, {
                  keypath: "login.terms.policyInfo",
                  class: "policy-info",
                  tag: "span"
                }, {
                  privacy: v(() => [
                    h("a", {
                      href: `${i(Gt)}?countryCode=${i(l).country}&client=1&isShowCountry=hide`,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": "Privacy Policy (opens in a new tab)",
                      "aria-describedby": "a11y-new-window-external-message",
                      onClick: _[6] || (_[6] = K(() => {
                      }, ["stop"]))
                    }, N(F.$t("login.terms.privacy")), 9, ra)
                  ]),
                  terms: v(() => [
                    h("a", {
                      href: "/pages/terms-conditions",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": "Terms & Conditions (opens in a new tab)",
                      "aria-describedby": "a11y-new-window-message",
                      onClick: _[7] || (_[7] = K(() => {
                      }, ["stop"]))
                    }, N(F.$t("login.terms.terms_html")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "class"])
          ], 512),
          g(i(be), {
            modelValue: o.value.subscribeNews,
            "onUpdate:modelValue": _[9] || (_[9] = (P) => o.value.subscribeNews = P),
            size: "sm",
            class: "item-subscribe",
            label: i(u)("login.newsletter.labelEmail"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"]),
          h("div", {
            class: "already-registered",
            onClick: A
          }, " I have registered ")
        ]),
        _: 1
      });
    };
  }
}, la = /* @__PURE__ */ le(ia, [["__scopeId", "data-v-b299135b"]]), ca = { class: "mc-login__container" }, ua = { class: "success-icon-wrapper" }, da = { class: "success-subtitle" }, fa = { class: "success-message" }, pa = {
  __name: "quickRegisterMember",
  props: {
    country: { type: String, default: "US" },
    activityType: { type: String },
    mustAgreeEmail: { type: Boolean, default: !1 },
    loginSubscribeNews: { type: Boolean, default: !1 },
    redirect: { type: String }
  },
  setup(e, { expose: t }) {
    const s = e, n = V({
      ...s
    });
    Pt("config", n);
    const r = V(!1), l = V(!1), u = Ce({}), o = V({
      account: "",
      babyBirthday: "",
      subscribeNews: 0
      // 协议
    });
    function c(C) {
      Object.assign(u, C), r.value = !1, l.value = !0, document.dispatchEvent(new Lo());
    }
    function d() {
      l.value = !1, m(!0);
    }
    async function a(C = {}, y = {}) {
      o.value = { ...o.value, ...C }, n.value = { ...s, ...y }, r.value = !0;
    }
    function m(C = !1) {
      if (n.value.persistent && !C) {
        document.dispatchEvent(new To());
        return;
      }
      r.value = !1, document.dispatchEvent(new xo());
    }
    return _e(async () => {
      document.addEventListener("LUTE:AUTH:EXPIRED", () => {
        Nt();
      });
      const C = Ze();
      if (C) {
        const y = await Zt();
        y && y.email && (window.__MOMCOZY_USER_INFO__ = {
          email: y.email,
          token: C
        }, document.body.classList.add("momcozy-logined"), document.dispatchEvent(
          new Eo({
            type: "keep",
            email: y.email,
            token: C
          })
        ));
      }
    }), t({
      close: m,
      open: a
    }), (C, y) => (x(), j(Be, null, [
      g(i($e), $t({
        modelValue: r.value,
        "onUpdate:modelValue": y[3] || (y[3] = (b) => r.value = b),
        class: "mc-login nt"
      }, n.value, {
        onShake: y[4] || (y[4] = (b) => m(!1))
      }), {
        default: v(() => [
          h("div", ca, [
            g(Rt, {
              name: "form",
              tag: "div",
              class: "mc-login__forms"
            }, {
              default: v(() => [
                g(la, {
                  key: "register",
                  form: o.value,
                  "onUpdate:form": y[0] || (y[0] = (b) => o.value = b),
                  onSuccess: c,
                  onClose: y[1] || (y[1] = (b) => m(!1))
                }, null, 8, ["form"])
              ]),
              _: 1
            }),
            g(i(te), {
              class: "mc-close-icon",
              icon: "close",
              flat: "",
              round: "",
              dense: "",
              onClick: y[2] || (y[2] = (b) => m(!1))
            })
          ])
        ]),
        _: 1
      }, 16, ["modelValue"]),
      g(i($e), {
        modelValue: l.value,
        "onUpdate:modelValue": y[5] || (y[5] = (b) => l.value = b),
        persistent: "",
        class: "success-dialog"
      }, {
        default: v(() => [
          g(i(ao), { class: "success-card" }, {
            default: v(() => [
              g(i(te), {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                class: "success-close-btn",
                onClick: d
              }),
              g(i(ro), { class: "success-content text-center" }, {
                default: v(() => [
                  y[7] || (y[7] = h("div", { class: "success-title" }, " Earn points on this purchase ", -1)),
                  h("div", ua, [
                    y[6] || (y[6] = h("img", {
                      src: na,
                      alt: "",
                      class: "success-icon"
                    }, null, -1)),
                    h("div", da, N(u.status === "success" ? "Sign-up successful!" : u.status === "notActivated" ? "Your account has not been created/activated!" : "You're already a Cozy Club member!"), 1)
                  ]),
                  h("div", fa, N(u.status === "success" ? "An initial password has been sent to your email. Check your inbox to view your points balance." : u.status === "notActivated" ? "Please register or check your activation email." : "your points will be automatically added after each purchase."), 1),
                  u.status === "success" ? (x(), D(i(te), {
                    key: 0,
                    unelevated: "",
                    color: "dark",
                    label: "OK",
                    class: "confirm-btn",
                    onClick: d
                  })) : ae("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64));
  }
}, ma = /* @__PURE__ */ le(pa, [["__scopeId", "data-v-9f634e1c"]]), no = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='common_icons_miniprogram'%3e%3cpath%20id='Oval%2078'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24%2048C10.7452%2048%200%2037.2548%200%2024C0%2010.7452%2010.7452%200%2024%200C37.2548%200%2048%2010.7452%2048%2024C48%2037.2548%2037.2548%2048%2024%2048Z'%20fill='%2307C160'/%3e%3cpath%20id='Combined%20Shape'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.1763%2029.1337L34.6146%2015.6953L37.1647%2018.2454L22.8793%2032.5249C21.9417%2033.462%2020.4219%2033.4616%2019.4849%2032.5239L12%2025.0336L14.5381%2022.4955L21.1763%2029.1337Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", va = { class: "diaglog-content" }, ga = {
  key: 1,
  class: "text-btn"
}, ya = { class: "btn-group" }, ha = {
  __name: "thirdLoginCompleteInfo",
  setup(e, { expose: t }) {
    const s = ye(), n = V(!1), r = V(!1), l = V(null), u = V(null), o = V({
      email: "",
      code: ""
    }), c = V({}), d = V(!1), a = V({}), m = Ce({
      email: [
        (w) => w && w.length > 0 || "Email is required.",
        (w, E) => E.email(w) || "Please enter a valid email address"
      ],
      code: [(w) => !!w || "Please enter correct code"]
    });
    let C = null;
    const y = V(60), b = V(!1), T = V(!1);
    function k(w, E) {
      let Z;
      return function(...J) {
        clearTimeout(Z), Z = setTimeout(() => w.apply(this, J), E);
      };
    }
    const I = k(async () => {
      if (y.value = 60, !await l.value.validate())
        return;
      const E = await Dn({
        email: o.value.email,
        sid: a.value.sid,
        type: 6
      });
      Reflect.has(E, "status") && (b.value = !0, T.value = !1, C = setInterval(() => {
        y.value--, y.value === 0 && (clearInterval(C), b.value = !1);
      }, 1e3), E?.status === 11 && (T.value = !0, s.notify({
        message: "The session has expired and needs to be restarted",
        color: "negative",
        position: "top",
        timeout: 3e3
      })));
    }, 300);
    async function A() {
      await l.value.validate() && I();
    }
    async function U() {
      if (d.value)
        document.dispatchEvent(
          new Ne({
            type: "assembly-login",
            ...c.value,
            sid: a.value.sid,
            platform: a.value.platform
          })
        ), n.value = !1;
      else {
        if (!await u.value.validate())
          return;
        r.value = !0;
        try {
          let E = await Hn({
            code: o.value.code,
            sid: a.value.sid
          });
          E = E || {}, c.value = E, E?.status === 11 ? s.notify({
            message: "The session has expired and needs to be restarted",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : E?.status === 12 ? s.notify({
            message: "Please enter the correct verification code",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : Reflect.has(E, "status") && (E.token && dt(E.token), d.value = !0);
        } catch (E) {
          console.error("Verify mail code failed:", E);
        } finally {
          r.value = !1;
        }
      }
    }
    function O() {
      document.dispatchEvent(
        new Ne({
          type: "assembly-login",
          ...c.value,
          sid: a.value.sid,
          platform: a.value.platform
        })
      ), n.value = !1;
    }
    function S(w = { sid: "", platform: "" }) {
      n.value = !0, u.value?.resetValidation(), o.value.email = "", o.value.code = "", c.value = {}, d.value = !1, b.value = !1, T.value = !1, y.value = 60, a.value = w;
    }
    return t({
      open: S
    }), (w, E) => {
      const Z = W("q-space"), J = W("q-btn"), Y = W("q-card-section"), ee = W("q-input"), X = W("q-form"), F = W("q-card-actions"), _ = W("q-card"), H = W("q-dialog"), P = Mt("close-popup");
      return x(), D(H, {
        modelValue: n.value,
        "onUpdate:modelValue": E[2] || (E[2] = (B) => n.value = B),
        persistent: "",
        onBeforeHide: O
      }, {
        default: v(() => [
          g(_, { style: { "max-width": "600px", "overflow-x": "hidden" } }, {
            default: v(() => [
              g(Y, { class: "row items-center q-pb-none q-pt-lg" }, {
                default: v(() => [
                  g(Z),
                  De(g(J, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [P]
                  ])
                ]),
                _: 1
              }),
              h("div", va, [
                g(Y, { class: "dialog-title" }, {
                  default: v(() => [
                    oe(N(d.value ? "Registration successful" : "Create account"), 1)
                  ]),
                  _: 1
                }),
                d.value ? (x(), D(Y, {
                  key: 0,
                  class: "row justify-center items-center q-py-none q-px-none q-pb-lg"
                }, {
                  default: v(() => [...E[3] || (E[3] = [
                    h("img", {
                      src: no,
                      alt: "",
                      srcset: "",
                      style: { width: "48px", height: "48px" }
                    }, null, -1)
                  ])]),
                  _: 1
                })) : ae("", !0),
                g(Y, { class: "dialog-des" }, {
                  default: v(() => [
                    oe(N(d.value ? `You have successfully registered, and your account has been linked to ${a.value.platform}. In the future, you can log in using ${a.value.platform} or your email.` : "Please provide the missing information so we can create a Momcozy account."), 1)
                  ]),
                  _: 1
                }),
                d.value ? ae("", !0) : (x(), D(F, {
                  key: 1,
                  class: "text-center q-pa-none"
                }, {
                  default: v(() => [
                    g(X, {
                      ref_key: "formRef",
                      ref: u,
                      class: "full-width",
                      onSubmit: K(U, ["prevent"])
                    }, {
                      default: v(() => [
                        g(ee, {
                          ref_key: "emailInput",
                          ref: l,
                          modelValue: o.value.email,
                          "onUpdate:modelValue": E[0] || (E[0] = (B) => o.value.email = B),
                          rules: m.email,
                          type: "text",
                          label: "* E-mail",
                          class: "q-pb-lg",
                          outlined: ""
                        }, {
                          append: v(() => [
                            b.value ? (x(), j("span", ga, N(y.value), 1)) : (x(), j("span", {
                              key: 0,
                              class: "text-btn cursor-pointer",
                              onClick: A
                            }, "Get code"))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        g(ee, {
                          modelValue: o.value.code,
                          "onUpdate:modelValue": E[1] || (E[1] = (B) => o.value.code = B),
                          rules: m.code,
                          type: "text",
                          class: "q-pb-lg",
                          label: "* Enter code",
                          outlined: ""
                        }, It({ _: 2 }, [
                          b.value && !T.value ? {
                            name: "hint",
                            fn: v(() => [
                              E[4] || (E[4] = oe(" A verification email has been sent to your inbox. Please check your email to verify your account. ", -1))
                            ]),
                            key: "0"
                          } : void 0
                        ]), 1032, ["modelValue", "rules"]),
                        h("div", ya, [
                          g(J, {
                            loading: r.value,
                            size: "lg",
                            class: "full-width",
                            label: "Confirm",
                            type: "submit",
                            color: "dark"
                          }, null, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })),
                d.value ? (x(), j("div", {
                  key: 2,
                  class: He(["btn-group", { success: d.value }])
                }, [
                  g(J, {
                    loading: r.value,
                    size: "lg",
                    class: "full-width",
                    label: "Confirm",
                    type: "submit",
                    color: "dark",
                    onClick: U
                  }, null, 8, ["loading"])
                ], 2)) : ae("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, _a = /* @__PURE__ */ le(ha, [["__scopeId", "data-v-75238e48"]]), ba = { class: "diaglog-content" }, wa = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ca = {
  key: 1,
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ka = { style: { "margin-top": "0", display: "flex", "justify-content": "flex-end", "align-items": "center" } }, Sa = ["href"], Ea = { class: "btn-group" }, Ta = {
  __name: "thirdVerifyPassword",
  setup(e, { expose: t }) {
    const s = ye(), { t: n } = ve(), r = V(!1), l = V(!1), u = V(null), o = V({
      password: ""
    }), c = V({}), d = V(!1), a = V("password"), m = V({}), C = Ce({
      password: [(k) => !!k || "Please enter your password"]
    });
    function y() {
      document.dispatchEvent(
        new Ne({
          type: "assembly-login",
          ...c.value,
          sid: m.value.sid,
          platform: m.value.platform
        })
      ), r.value = !1;
    }
    async function b() {
      if (d.value)
        document.dispatchEvent(
          new Ne({
            type: "assembly-login",
            ...c.value,
            sid: m.value.sid,
            platform: m.value.platform
          })
        ), r.value = !1;
      else {
        if (!await u.value.validate())
          return;
        const I = jt(o.value.password);
        try {
          const A = await jn({
            password: I,
            secretValue: await ze(o.value.password),
            secretType: 1,
            sid: m.value.sid
          }).finally(() => {
            l.value = !1;
          });
          c.value = A ? { ...A } : {}, c.value?.status === 11 ? s.notify({
            message: "The session has expired and needs to be restarted",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : Object.prototype.hasOwnProperty.call(c.value, "status") && (A.token && dt(A.token), d.value = !0);
        } catch {
          l.value = !1;
        }
      }
    }
    function T(k = { sid: "", platform: "", email: "" }) {
      r.value = !0, u.value?.resetValidation(), o.value.password = "", c.value = {}, d.value = !1, m.value = k;
    }
    return t({
      open: T
    }), (k, I) => {
      const A = W("q-space"), U = W("q-btn"), O = W("q-card-section"), S = W("svg-icon"), w = W("q-input"), E = W("q-form"), Z = W("q-card-actions"), J = W("q-card"), Y = W("q-dialog"), ee = Mt("close-popup");
      return x(), D(Y, {
        modelValue: r.value,
        "onUpdate:modelValue": I[3] || (I[3] = (X) => r.value = X),
        persistent: "",
        onBeforeHide: y
      }, {
        default: v(() => [
          g(J, { style: { "max-width": "600px", "overflow-x": "hidden" } }, {
            default: v(() => [
              g(O, { class: "row items-center q-pb-none q-pt-lg" }, {
                default: v(() => [
                  g(A),
                  De(g(U, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [ee]
                  ])
                ]),
                _: 1
              }),
              h("div", ba, [
                g(O, { class: "dialog-title" }, {
                  default: v(() => [
                    oe(N(d.value ? "Login successful" : "Verify password"), 1)
                  ]),
                  _: 1
                }),
                d.value ? (x(), D(O, {
                  key: 0,
                  class: "row justify-center items-center q-py-none q-px-none q-pb-lg"
                }, {
                  default: v(() => [...I[4] || (I[4] = [
                    h("img", {
                      src: no,
                      alt: "",
                      srcset: "",
                      style: { width: "48px", height: "48px" }
                    }, null, -1)
                  ])]),
                  _: 1
                })) : ae("", !0),
                g(O, { class: "dialog-des" }, {
                  default: v(() => [
                    oe(N(d.value ? `You have successfully logged in, and your account has been linked to ${m.value.platform}. In the future, you can log in using ${m.value.platform} or your email.` : `The email ${m.value.email} is already registered with Momcozy. Is this the email you are using? If so,
          please enter your Momcozy account password to link your ${m.value.platform} account.`), 1)
                  ]),
                  _: 1
                }),
                d.value ? ae("", !0) : (x(), D(Z, {
                  key: 1,
                  class: "text-center q-pa-none"
                }, {
                  default: v(() => [
                    g(E, {
                      ref_key: "formRef",
                      ref: u,
                      class: "full-width",
                      onSubmit: K(b, ["prevent"])
                    }, {
                      default: v(() => [
                        g(w, {
                          modelValue: o.value.password,
                          "onUpdate:modelValue": I[2] || (I[2] = (X) => o.value.password = X),
                          rules: C.password,
                          type: a.value,
                          label: "* Password",
                          class: "q-pb-lg",
                          outlined: ""
                        }, {
                          append: v(() => [
                            g(S, {
                              class: "cursor-pointer",
                              name: a.value === "password" ? "hide_password" : "show_password",
                              onClick: I[0] || (I[0] = (X) => a.value = a.value === "password" ? "text" : "password")
                            }, null, 8, ["name"]),
                            h("span", {
                              class: "cursor-pointer",
                              onClick: I[1] || (I[1] = (X) => a.value = a.value === "password" ? "text" : "password")
                            }, [
                              a.value === "password" ? (x(), j("svg", wa, [...I[5] || (I[5] = [
                                h("g", { id: "Frame" }, [
                                  h("path", {
                                    id: "Ellipse 79",
                                    d: "M13.907 5C12.4401 6.66563 10.2728 7.71945 7.85489 7.71945C5.43701 7.71945 3.26966 6.66563 1.80273 5",
                                    stroke: "#97999B",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round"
                                  }),
                                  h("path", {
                                    id: "Vector 8",
                                    d: "M7.35 11.5C7.35 11.859 7.64101 12.15 8 12.15C8.35899 12.15 8.65 11.859 8.65 11.5H7.35ZM8.65 8.5V7.85H7.35V8.5H8.65ZM8.65 11.5V8.5H7.35V11.5H8.65Z",
                                    fill: "#97999B"
                                  }),
                                  h("path", {
                                    id: "Vector 9",
                                    d: "M12.9371 10.9231C13.1166 11.234 13.5141 11.3405 13.825 11.161C14.1359 10.9815 14.2424 10.584 14.0629 10.2731L12.9371 10.9231ZM12.5629 7.675L12.2379 7.11208L11.1121 7.76208L11.4371 8.325L12.5629 7.675ZM14.0629 10.2731L12.5629 7.675L11.4371 8.325L12.9371 10.9231L14.0629 10.2731Z",
                                    fill: "#97999B"
                                  }),
                                  h("path", {
                                    id: "Vector 10",
                                    d: "M2.81292 10.9231C2.63342 11.234 2.23589 11.3405 1.925 11.161C1.61411 10.9815 1.50759 10.584 1.68708 10.2731L2.81292 10.9231ZM3.18708 7.675L3.51208 7.11208L4.63792 7.76208L4.31292 8.325L3.18708 7.675ZM1.68708 10.2731L3.18708 7.675L4.31292 8.325L2.81292 10.9231L1.68708 10.2731Z",
                                    fill: "#97999B"
                                  })
                                ], -1)
                              ])])) : (x(), j("svg", Ca, [...I[6] || (I[6] = [
                                h("g", {
                                  id: "Frame",
                                  "clip-path": "url(#clip0_1844_7198)"
                                }, [
                                  h("g", { id: "Intersect" }, [
                                    h("mask", {
                                      id: "path-1-inside-1_1844_7198",
                                      fill: "white"
                                    }, [
                                      h("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M0.498047 8.76838C1.30429 4.69775 4.95296 1.625 9.33212 1.625C13.7193 1.625 17.3733 4.709 18.1706 8.79073C17.3644 12.8614 13.7157 15.9341 9.33652 15.9341C4.94934 15.9341 1.29534 12.8501 0.498047 8.76838Z"
                                      })
                                    ]),
                                    h("path", {
                                      d: "M0.498047 8.76838L-0.777181 8.51581L-0.826862 8.76664L-0.77784 9.0176L0.498047 8.76838ZM18.1706 8.79073L19.4458 9.0433L19.4955 8.79247L19.4465 8.54151L18.1706 8.79073ZM1.77327 9.02096C2.45817 5.56296 5.5696 2.925 9.33212 2.925V0.325C4.33631 0.325 0.150401 3.83254 -0.777181 8.51581L1.77327 9.02096ZM9.33212 2.925C13.1016 2.925 16.2174 5.57264 16.8947 9.03995L19.4465 8.54151C18.5292 3.84537 14.337 0.325 9.33212 0.325V2.925ZM16.8954 8.53815C16.2105 11.9961 13.099 14.6341 9.33652 14.6341V17.2341C14.3323 17.2341 18.5182 13.7266 19.4458 9.0433L16.8954 8.53815ZM9.33652 14.6341C5.56707 14.6341 2.45121 11.9865 1.77393 8.51916L-0.77784 9.0176C0.139468 13.7137 4.33161 17.2341 9.33652 17.2341V14.6341Z",
                                      fill: "#97999B",
                                      mask: "url(#path-1-inside-1_1844_7198)"
                                    })
                                  ]),
                                  h("circle", {
                                    id: "Ellipse 77",
                                    cx: "9.5",
                                    cy: "8.82617",
                                    r: "2.725",
                                    stroke: "#97999B",
                                    "stroke-width": "1.3"
                                  })
                                ], -1),
                                h("defs", null, [
                                  h("clipPath", { id: "clip0_1844_7198" }, [
                                    h("rect", {
                                      width: "18",
                                      height: "18",
                                      fill: "white",
                                      transform: "translate(0.5 0.5)"
                                    })
                                  ])
                                ], -1)
                              ])]))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules", "type"]),
                        h("div", ka, [
                          h("a", {
                            href: i(oo),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "aria-label": "forget password (opens in a new tab)",
                            "aria-describedby": "a11y-new-window-message"
                          }, N(i(n)("login.actions.forgotPassword")), 9, Sa)
                        ]),
                        h("div", Ea, [
                          g(U, {
                            loading: l.value,
                            size: "lg",
                            class: "full-width",
                            label: "Confirm",
                            type: "submit",
                            color: "dark"
                          }, null, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })),
                d.value ? (x(), j("div", {
                  key: 2,
                  class: He(["btn-group", { success: d.value }])
                }, [
                  g(U, {
                    loading: l.value,
                    size: "lg",
                    class: "full-width",
                    label: "Confirm",
                    type: "submit",
                    color: "dark",
                    onClick: b
                  }, null, 8, ["loading"])
                ], 2)) : ae("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, xa = /* @__PURE__ */ le(Ta, [["__scopeId", "data-v-20dc5b13"]]);
(function(e) {
  if (typeof e > "u")
    throw new Error("Geetest requires browser environment");
  var t = e.document, s = e.Math, n = t.getElementsByTagName("head")[0], r = 1e4;
  function l(f) {
    this._obj = f;
  }
  l.prototype = {
    _each: function(f) {
      var $ = this._obj;
      for (var p in $)
        $.hasOwnProperty(p) && f(p, $[p]);
      return this;
    },
    _extend: function(f) {
      var $ = this;
      new l(f)._each(function(p, L) {
        $._obj[p] = L;
      });
    }
  };
  var u = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(f) {
      var $ = s.random() * 16 | 0, p = f === "x" ? $ : $ & 3 | 8;
      return p.toString(16);
    });
  };
  function o(f) {
    var $ = this;
    new l(f)._each(function(p, L) {
      $[p] = L;
    });
  }
  o.prototype = {
    apiServers: ["gcaptcha4.geetest.com", "gcaptcha4.geevisit.com", "gcaptcha4.gsensebot.com"],
    staticServers: ["static.geetest.com", "static.geevisit.com"],
    protocol: "http://",
    typePath: "/load",
    fallback_config: {
      bypass: {
        staticServers: ["static.geetest.com", "static.geevisit.com"],
        type: "bypass",
        bypass: "/v4/bypass.js"
      }
    },
    _get_fallback_config: function() {
      var f = this;
      return d(f.type) ? f.fallback_config[f.type] : f.fallback_config.bypass;
    },
    _extend: function(f) {
      var $ = this;
      new l(f)._each(function(p, L) {
        $[p] = L;
      });
    }
  };
  var c = function(f) {
    return typeof f == "number";
  }, d = function(f) {
    return typeof f == "string";
  }, a = function(f) {
    return typeof f == "boolean";
  }, m = function(f) {
    return typeof f == "object" && f !== null;
  }, C = function(f) {
    return typeof f == "function";
  }, y = /Mobi/i.test(navigator.userAgent), b = {}, T = {}, k = function() {
    return parseInt(s.random() * 1e4) + (/* @__PURE__ */ new Date()).valueOf();
  }, I = function(f, $) {
    if (typeof f == "function") {
      var p = Array.prototype.slice.call(arguments, 2);
      return Function.prototype.bind ? f.bind($, p) : function() {
        var L = Array.prototype.slice.call(arguments);
        return f.apply($, p.concat(L));
      };
    }
  }, A = Object.prototype.toString, U = function(f) {
    return typeof f == "function";
  }, O = function(f) {
    return f === Object(f);
  }, S = function(f) {
    return A.call(f) == "[object Array]";
  }, w = function(f) {
    return A.call(f) == "[object Date]";
  }, E = function(f) {
    return A.call(f) == "[object RegExp]";
  }, Z = function(f) {
    return A.call(f) == "[object Boolean]";
  };
  function J(f) {
    return f.replace(/(\S)(_([a-zA-Z]))/g, function($, p, L, R) {
      return p + R.toUpperCase() || "";
    });
  }
  function Y(f, $) {
    if (!O(f) || w(f) || E(f) || Z(f) || U(f))
      return $ ? J(f) : f;
    if (S(f))
      for (var p = [], L = 0; L < f.length; L++)
        p.push(Y(f[L]));
    else {
      var p = {};
      for (var R in f)
        f.hasOwnProperty(R) && (p[Y(R, !0)] = Y(f[R]));
    }
    return p;
  }
  var ee = function(f, $, p) {
    var L = t.createElement("script");
    L.charset = "UTF-8", L.async = !0, /static\.geetest\.com/g.test(f) && (L.crossOrigin = "anonymous"), L.onerror = function() {
      $(!0), R = !0;
    };
    var R = !1;
    L.onload = L.onreadystatechange = function() {
      !R && (!L.readyState || L.readyState === "loaded" || L.readyState === "complete") && (R = !0, setTimeout(function() {
        $(!1);
      }, 0));
    }, L.src = f, n.appendChild(L), setTimeout(function() {
      R || (L.onerror = L.onload = null, L.remove && L.remove(), $(!0));
    }, p || r);
  }, X = function(f) {
    return f.replace(/^https?:\/\/|\/$/g, "");
  }, F = function(f) {
    return f = f && f.replace(/\/+/g, "/"), f.indexOf("/") !== 0 && (f = "/" + f), f;
  }, _ = function(f) {
    if (!f)
      return "";
    var $ = "?";
    return new l(f)._each(function(p, L) {
      (d(L) || c(L) || a(L)) && ($ = $ + encodeURIComponent(p) + "=" + encodeURIComponent(L) + "&");
    }), $ === "?" && ($ = ""), $.replace(/&$/, "");
  }, H = function(f, $, p, L) {
    $ = X($);
    var R = F(p) + _(L);
    return $ && (R = f + $ + R), R;
  }, P = function(f, $, p, L, R, q, ne) {
    var ce = function(G) {
      if (ne) {
        var M = "geetest_" + k();
        e[M] = I(ne, null, M), R.callback = M;
      }
      var se = H($, p[G], L, R);
      ee(se, function(z) {
        if (z) {
          if (M)
            try {
              e[M] = function() {
                e[M] = null;
              };
            } catch {
            }
          G >= p.length - 1 ? q(!0) : ce(G + 1);
        } else
          q(!1);
      }, f.timeout);
    };
    ce(0);
  }, B = function(f, $, p, L) {
    var R = function(q, ne) {
      ne.status == "success" ? L(ne.data) : (ne.status, L(ne)), e[q] = void 0;
      try {
        delete e[q];
      } catch {
      }
    };
    P(p, p.protocol, f, $, {
      callback: "",
      captcha_id: p.captchaId,
      challenge: p.challenge || u(),
      client_type: p.clientType ? p.clientType : y ? "h5" : "web",
      risk_type: p.riskType,
      user_info: p.userInfo,
      call_type: p.callType,
      lang: p.language ? p.language : navigator.appName === "Netscape" ? navigator.language.toLowerCase() : navigator.userLanguage.toLowerCase()
    }, function(q) {
      if (q && typeof p.offlineCb == "function") {
        p.offlineCb();
        return;
      }
      q && L(p._get_fallback_config());
    }, R);
  }, re = function(f, $, p) {
    var L = {
      networkError: "缃戠粶閿欒",
      gtTypeError: "gt瀛楁涓嶆槸瀛楃涓茬被鍨�"
    };
    if (typeof $.onError == "function")
      $.onError({
        desc: p.desc,
        msg: p.msg,
        code: p.code
      });
    else
      throw new Error(L[f]);
  }, he = function() {
    return e.Geetest || t.getElementById("gt_lib");
  };
  he() && (T.slide = "loaded");
  var Xe = function(f) {
    var $ = !1, p = { js: "script", css: "link" }, L = f && p[f.split(".").pop()];
    if (L !== void 0) {
      var R = t.getElementsByTagName(L);
      for (var q in R)
        (R[q].href && R[q].href.toString().indexOf(f) > 0 || R[q].src && R[q].src.toString().indexOf(f) > 0) && ($ = !0);
    }
    return $;
  };
  e.initGeetest4 = function(f, $) {
    var p = new o(f);
    f.https ? p.protocol = "https://" : f.protocol || (p.protocol = e.location.protocol + "//"), m(f.getType) && p._extend(f.getType), B(p.apiServers, p.typePath, p, function(R) {
      var R = Y(R);
      if (R.status === "error")
        return re("networkError", p, R);
      var q = R.type;
      p.debug && new l(R)._extend(p.debug);
      var ne = function() {
        p._extend(R), $(new e.Geetest4(p));
      };
      b[q] = b[q] || [];
      var ce = T[q] || "init";
      if (ce === "init")
        T[q] = "loading", b[q].push(ne), R.gctPath && P(p, p.protocol, Object.hasOwnProperty.call(p, "staticServers") ? p.staticServers : R.staticServers || p.staticServers, R.gctPath, null, function(G) {
          G && re("networkError", p, {
            code: "60205",
            msg: "Network failure",
            desc: {
              detail: "gct resource load timeout"
            }
          });
        }), P(p, p.protocol, Object.hasOwnProperty.call(p, "staticServers") ? p.staticServers : R.staticServers || p.staticServers, R.bypass || R.staticPath + R.js, null, function(G) {
          if (G)
            T[q] = "fail", re("networkError", p, {
              code: "60204",
              msg: "Network failure",
              desc: {
                detail: "js resource load timeout"
              }
            });
          else {
            T[q] = "loaded";
            for (var M = b[q], se = 0, z = M.length; se < z; se = se + 1) {
              var We = M[se];
              C(We) && We();
            }
            b[q] = [], T[q] = "init";
          }
        });
      else {
        if (ce === "loaded")
          return R.gctPath && !Xe(R.gctPath) && P(p, p.protocol, Object.hasOwnProperty.call(p, "staticServers") ? p.staticServers : R.staticServers || p.staticServers, R.gctPath, null, function(G) {
            G && re("networkError", p, {
              code: "60205",
              msg: "Network failure",
              desc: {
                detail: "gct resource load timeout"
              }
            });
          }), ne();
        ce === "fail" ? re("networkError", p, {
          code: "60204",
          msg: "Network failure",
          desc: {
            detail: "js resource load timeout"
          }
        }) : ce === "loading" && b[q].push(ne);
      }
    });
  };
})(window);
const Ye = io || globalThis.Quasar, Le = /* @__PURE__ */ Symbol.for("login-element-instance"), Ve = /* @__PURE__ */ Symbol.for("third-verify-password-element-instance"), Ie = /* @__PURE__ */ Symbol.for("third-login-complete-info-element-instance"), Pe = /* @__PURE__ */ Symbol.for("quick-register-member-element-instance"), La = je(oa, {
  configureApp(e) {
    e.use(Ye, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: Ee,
        Loading: lt
      }
    }), e.provide(Ge, pe), e.use(pe);
  }
});
class Va extends La {
  connectedCallback() {
    const t = window[Le];
    t && t !== this && document.contains(t) && this.remove(), window[Le] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Le] === this && (window[Le] = null), super.disconnectedCallback();
  }
}
customElements.get("login-dialog") || customElements.define("login-dialog", Va);
const Ia = je(xa, {
  configureApp(e) {
    e.use(Ye, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: Ee,
        Loading: lt
      }
    }), e.provide(Ge, pe), e.use(pe);
  }
});
class Pa extends Ia {
  connectedCallback() {
    const t = window[Ve];
    t && t !== this && document.contains(t) && this.remove(), window[Ve] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Ve] === this && (window[Ve] = null), super.disconnectedCallback();
  }
}
customElements.get("third-verify-password-dialog") || customElements.define("third-verify-password-dialog", Pa);
const $a = je(_a, {
  configureApp(e) {
    e.use(Ye, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: Ee,
        Loading: lt
      }
    }), e.provide(Ge, pe), e.use(pe);
  }
});
class Ra extends $a {
  connectedCallback() {
    const t = window[Ie];
    t && t !== this && document.contains(t) && this.remove(), window[Ie] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Ie] === this && (window[Ie] = null), super.disconnectedCallback();
  }
}
customElements.get("third-login-complete-info-dialog") || customElements.define("third-login-complete-info-dialog", Ra);
const Ma = je(ma, {
  configureApp(e) {
    e.use(Ye, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: Ee
      }
    }), e.provide(Ge, pe), e.use(pe);
  }
});
class Oa extends Ma {
  connectedCallback() {
    const t = window[Pe];
    t && t !== this && document.contains(t) && this.remove(), window[Pe] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Pe] === this && (window[Pe] = null), super.disconnectedCallback();
  }
}
customElements.get("quick-register-member-dialog") || customElements.define("quick-register-member-dialog", Oa);
